import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import * as ApolloCore from '@apollo/client/core';
import { EncounterGraphQLModule } from './graphql.module';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type Account = {
  __typename?: 'Account';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  apiKeys?: Maybe<Array<Maybe<ApiKey>>>;
  displayNameLong?: Maybe<Scalars['String']>;
  displayNameShort?: Maybe<Scalars['String']>;
  estimateConfigs?: Maybe<Array<Maybe<EstimateConfig>>>;
  externalReferenceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Address = {
  __typename?: 'Address';
  addressType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countyOrParish?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  otherDesignation?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  verification?: Maybe<AddressVerification>;
  zipOrPostalCode?: Maybe<Scalars['String']>;
};

export type AddressData = {
  __typename?: 'AddressData';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  addressType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countyOrParish?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherDesignation?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  verification?: InputMaybe<AddressVerificationInput>;
  zipOrPostalCode?: InputMaybe<Scalars['String']>;
};

export type AddressVerification = {
  __typename?: 'AddressVerification';
  addressStandardized?: Maybe<Scalars['Boolean']>;
  addressUpdated?: Maybe<Scalars['Boolean']>;
  lastVerifiedOn?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<AddressVerificationMessage>>;
  originalAddress?: Maybe<Address>;
  status?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['Boolean']>;
  verificationResultId?: Maybe<Scalars['Int']>;
  verifiedAddress?: Maybe<Address>;
};

export type AddressVerificationInput = {
  addressStandardized?: InputMaybe<Scalars['Boolean']>;
  addressUpdated?: InputMaybe<Scalars['Boolean']>;
  lastVerifiedOn?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<AddressVerificationMessageInput>>;
  originalAddress?: InputMaybe<AddressInput>;
  status?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  verificationResultId?: InputMaybe<Scalars['Int']>;
  verifiedAddress?: InputMaybe<AddressInput>;
};

export type AddressVerificationMessage = {
  __typename?: 'AddressVerificationMessage';
  error: Scalars['Boolean'];
  footnote?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  warning: Scalars['Boolean'];
};

export type AddressVerificationMessageInput = {
  error?: Scalars['Boolean'];
  footnote?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  warning?: Scalars['Boolean'];
};

export type AlertMaster = {
  __typename?: 'AlertMaster';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  payerLabel?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  accountId: Scalars['Float'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Benefit = {
  __typename?: 'Benefit';
  deductible?: Maybe<Array<Maybe<BenefitOutOfPocketMax>>>;
  eligibility?: Maybe<Array<Maybe<BenefitEligibility>>>;
  limit?: Maybe<Array<Maybe<BenefitLimit>>>;
  outOfPocketMax?: Maybe<Array<Maybe<BenefitOutOfPocketMax>>>;
  service?: Maybe<Array<Maybe<BenefitService>>>;
  spendingAccount?: Maybe<Array<Maybe<BenefitSpendingAccount>>>;
};

export type BenefitBurndown = {
  __typename?: 'BenefitBurndown';
  coinsurance?: Maybe<Scalars['Boolean']>;
  copay?: Maybe<Scalars['Boolean']>;
};

export type BenefitBurndownInput = {
  coinsurance?: InputMaybe<Scalars['Boolean']>;
  copay?: InputMaybe<Scalars['Boolean']>;
};

export type BenefitEligibility = {
  __typename?: 'BenefitEligibility';
  benefitType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  error?: Maybe<ParseError>;
  flags?: Maybe<BenefitFlags>;
  id: Scalars['ID'];
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  placeOfService?: Maybe<Array<Maybe<BenefitPlaceOfService>>>;
  serviceTypeCode?: Maybe<Scalars['String']>;
};

export type BenefitFlags = {
  __typename?: 'BenefitFlags';
  isMedicarePartA?: Maybe<Scalars['Boolean']>;
  isMedicarePartB?: Maybe<Scalars['Boolean']>;
};

export type BenefitLimit = {
  __typename?: 'BenefitLimit';
  benefitType?: Maybe<Scalars['String']>;
  coverageLevel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dollarMax?: Maybe<Scalars['Float']>;
  dollarRemaining?: Maybe<Scalars['Float']>;
  error?: Maybe<ParseError>;
  hasRemaining?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insuranceTypeCode?: Maybe<Scalars['String']>;
  lifetimeMax?: Maybe<Scalars['Float']>;
  lifetimeUsed?: Maybe<Scalars['Float']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  network?: Maybe<Scalars['String']>;
  periodCount?: Maybe<Scalars['Int']>;
  periodType?: Maybe<Scalars['String']>;
  periodUnit?: Maybe<Scalars['String']>;
  remaining?: Maybe<Scalars['Float']>;
  serviceTypeCode?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceBenefitCode?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Float']>;
};

export type BenefitOutOfPocketMax = {
  __typename?: 'BenefitOutOfPocketMax';
  amount?: Maybe<Scalars['Float']>;
  benefitType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  error?: Maybe<ParseError>;
  flags?: Maybe<BenefitFlags>;
  id: Scalars['ID'];
  insuranceTypeCode?: Maybe<Scalars['String']>;
  member?: Maybe<Scalars['Int']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  network?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['String']>;
  remaining?: Maybe<Scalars['Float']>;
  serviceTypeCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Float']>;
};

export type BenefitPlaceOfService = {
  __typename?: 'BenefitPlaceOfService';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type BenefitPlaceOfServiceInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type BenefitService = {
  __typename?: 'BenefitService';
  benefitType?: Maybe<Scalars['String']>;
  burnsDeductible?: Maybe<BenefitBurndown>;
  burnsOutOfPocket?: Maybe<BenefitBurndown>;
  coinsurance?: Maybe<Scalars['Float']>;
  copay?: Maybe<Scalars['Float']>;
  copayMessageFlags?: Maybe<Array<Scalars['String']>>;
  coverageLevel?: Maybe<Scalars['String']>;
  deductibleApplies?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  error?: Maybe<ParseError>;
  flags?: Maybe<BenefitFlags>;
  id: Scalars['ID'];
  insuranceTypeCode?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  network?: Maybe<Scalars['String']>;
  placeOfService?: Maybe<Array<Maybe<BenefitPlaceOfService>>>;
  serviceType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BenefitSpendingAccount = {
  __typename?: 'BenefitSpendingAccount';
  accountType?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  benefitType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  error?: Maybe<ParseError>;
  id: Scalars['ID'];
  insuranceTypeCode?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  network?: Maybe<Scalars['String']>;
  remaining?: Maybe<Scalars['Float']>;
  serviceTypeCode?: Maybe<Scalars['String']>;
  sourceBenefitCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Float']>;
};

export enum BenefitStatus {
  Active = 'Active',
  ActivePartA = 'ActivePartA',
  ActivePartB = 'ActivePartB',
  Error = 'Error',
  InsufficientSearchCriteria = 'InsufficientSearchCriteria',
  InsuranceNotUsed = 'InsuranceNotUsed',
  MemberNotFound = 'MemberNotFound',
  NonCovered = 'NonCovered',
  NotActive = 'NotActive',
  NotApplicable = 'NotApplicable',
  NotRun = 'NotRun',
  PayerUnavailable = 'PayerUnavailable',
  ProviderEnrollmentIssue = 'ProviderEnrollmentIssue',
  ResultsPending = 'ResultsPending',
  UnableToDetermine = 'UnableToDetermine',
  UnmappedPayer = 'UnmappedPayer'
}

export type ChargeMaster = {
  __typename?: 'ChargeMaster';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type CommunicationConsent = {
  __typename?: 'CommunicationConsent';
  callsAllowed: Scalars['Boolean'];
  emailAllowed: Scalars['Boolean'];
  smsAllowed: Scalars['Boolean'];
};

export type CommunicationConsentInput = {
  callsAllowed: Scalars['Boolean'];
  emailAllowed: Scalars['Boolean'];
  smsAllowed: Scalars['Boolean'];
};

export type CommunicationFilter = {
  __typename?: 'CommunicationFilter';
  email?: Maybe<Scalars['String']>;
  sms?: Maybe<Scalars['String']>;
};

export type CommunicationFilterInput = {
  email?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['String']>;
};

export type ConsumerStatement = {
  __typename?: 'ConsumerStatement';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  Address3?: Maybe<Scalars['String']>;
  AmountDue?: Maybe<Scalars['String']>;
  BCL?: Maybe<Scalars['String']>;
  Charity?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  ConsumerNumber?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreateDate?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  DiscountPercent?: Maybe<Scalars['String']>;
  DunningLevel?: Maybe<Scalars['String']>;
  DunningType?: Maybe<Scalars['String']>;
  FPL?: Maybe<Scalars['String']>;
  Facility?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  FirstStatementDate?: Maybe<Scalars['String']>;
  FullName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  LastStatementDate?: Maybe<Scalars['String']>;
  LetterCode?: Maybe<Scalars['String']>;
  MiddleName?: Maybe<Scalars['String']>;
  PaymentDueDate?: Maybe<Scalars['String']>;
  PaymentPlanAmountDue?: Maybe<Scalars['String']>;
  PdfId?: Maybe<Scalars['String']>;
  PromptPayDiscountAmount?: Maybe<Scalars['String']>;
  PromptPayDiscountFlag?: Maybe<Scalars['String']>;
  PromptPayEndDate?: Maybe<Scalars['String']>;
  PromptPayFlag?: Maybe<Scalars['String']>;
  RunStampDate?: Maybe<Scalars['String']>;
  Score?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  StatementAccount?: Maybe<Array<StatementAccount>>;
  StatementDate?: Maybe<Scalars['String']>;
  StatementId?: Maybe<Scalars['String']>;
  StatementMessage?: Maybe<Scalars['String']>;
  StatementNumber?: Maybe<Scalars['String']>;
  SuppressionFlag?: Maybe<Scalars['String']>;
  SuppressionReason?: Maybe<Scalars['String']>;
  TotalBalance?: Maybe<Scalars['String']>;
  TotalCredits?: Maybe<Scalars['String']>;
  TotalDebits?: Maybe<Scalars['String']>;
  UpdateDate?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

export type ContactData = {
  __typename?: 'ContactData';
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<AddressData>;
  cityOfBirth?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<EmailData>;
  ethnicity?: Maybe<Scalars['String']>;
  financialClass?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  name?: Maybe<NameData>;
  organizationName?: Maybe<Scalars['String']>;
  phone?: Maybe<PhoneData>;
  relationship?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ContactPeriod = {
  __typename?: 'ContactPeriod';
  end?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
};

export type ContactPoint = {
  __typename?: 'ContactPoint';
  anyText?: Maybe<Scalars['String']>;
  consent?: Maybe<Scalars['String']>;
  period?: Maybe<ContactPeriod>;
  rank: Scalars['Int'];
  system?: Maybe<Scalars['String']>;
  use?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CreateEncounterCommunicationInput = {
  alias?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Float']>;
  channel?: InputMaybe<Scalars['String']>;
  communicationContext: EncounterCommunicationContextInput;
  dateSent?: InputMaybe<Scalars['DateTime']>;
  destination?: InputMaybe<Scalars['String']>;
  encounterId: Scalars['String'];
  estimateSessionId?: InputMaybe<Scalars['String']>;
  formSessionId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  redirectToEncounterCommunicationId?: InputMaybe<Scalars['Int']>;
  sent?: InputMaybe<Scalars['Boolean']>;
  shouldSend?: InputMaybe<Scalars['Boolean']>;
  skipEnsHandler?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EncounterCommunicationType>;
};

export type CreateEstimateInput = {
  addresses?: InputMaybe<Array<AddressInput>>;
  amounts?: InputMaybe<EstimateAmountsInput>;
  attachments?: InputMaybe<EstimateAttachmentInput>;
  auxiliaryData?: InputMaybe<Scalars['JSON']>;
  checksum?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dateOfService?: InputMaybe<Scalars['DateTime']>;
  diagnosis?: InputMaybe<Array<DiagnosisInput>>;
  estimateNumber?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<EstimateInsuranceInput>;
  manualEstimateReason?: InputMaybe<Scalars['JSON']>;
  mrn?: InputMaybe<Scalars['String']>;
  patientDob?: InputMaybe<Scalars['DateTime']>;
  patientNameFirst?: InputMaybe<Scalars['String']>;
  patientNameLast?: InputMaybe<Scalars['String']>;
  patientNameMiddle?: InputMaybe<Scalars['String']>;
  primaryService?: InputMaybe<Scalars['String']>;
  providerLocation?: InputMaybe<ProviderLocationInput>;
  providerName?: InputMaybe<Scalars['String']>;
  providerNpi?: InputMaybe<Scalars['String']>;
  providerTin?: InputMaybe<Scalars['String']>;
  referenceIds?: InputMaybe<Scalars['JSON']>;
  serviceGroups?: InputMaybe<Array<InputMaybe<EstimateServiceGroupInput>>>;
  source: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  visitNumber?: InputMaybe<Scalars['String']>;
};

export type CreateSessionInput = {
  authenticationFields?: InputMaybe<Array<InputMaybe<SaveSessionAuthCommand>>>;
  externalReferenceId: Scalars['String'];
  organizationId: Scalars['Float'];
  packets?: InputMaybe<Scalars['JSON']>;
  paths?: InputMaybe<Array<Scalars['String']>>;
  sessionData?: InputMaybe<Array<InputMaybe<SaveSessionDataCommand>>>;
  signers?: InputMaybe<Array<InputMaybe<SaveSessionSignersCommand>>>;
};

export type DeleteEstimatesInput = {
  externalReferenceId: Scalars['String'];
  previewFlag: Scalars['Boolean'];
  sessionType: Scalars['String'];
};

export type DeleteEstimatesResponse = {
  __typename?: 'DeleteEstimatesResponse';
  estimates?: Maybe<Array<Estimate>>;
  s3Responses?: Maybe<Array<DeleteFromS3Response>>;
};

export type DeleteFromS3Response = {
  __typename?: 'DeleteFromS3Response';
  deleted: Scalars['Boolean'];
  entityId: Scalars['Float'];
  entityType: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type DiagnosisInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export enum DoctorType {
  Admitting = 'admitting',
  Attending = 'attending',
  Consulting = 'consulting',
  Referring = 'referring'
}

export type Email = {
  __typename?: 'Email';
  anyText?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
};

export type EmailData = {
  __typename?: 'EmailData';
  home?: Maybe<Scalars['String']>;
  work?: Maybe<Scalars['String']>;
};

export type EmbeddedEstimateAttachmentContent = EstimateAttachmentContentType & {
  __typename?: 'EmbeddedEstimateAttachmentContent';
  password?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  sourceUrl: Scalars['String'];
  type: Scalars['String'];
};

export type EmbeddedEstimateAttachmentContentInput = {
  sourceUrl: Scalars['String'];
  type: Scalars['String'];
};

export type EmbeddedEstimateAttachmentInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<EmbeddedEstimateAttachmentContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EmergencyContactBase = {
  __typename?: 'EmergencyContactBase';
  addresses?: Maybe<Array<Address>>;
  authorizeRelease: Scalars['Boolean'];
  contactPoints?: Maybe<Array<ContactPoint>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  emails?: Maybe<Array<Email>>;
  leaveMessage: Scalars['Boolean'];
  nameFamily?: Maybe<Scalars['String']>;
  nameGiven?: Maybe<Scalars['String']>;
  nameMiddle?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  patientRelationship?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  sex?: Maybe<Scalars['String']>;
};

export type EmployerData = {
  __typename?: 'EmployerData';
  address?: Maybe<AddressData>;
  language?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<AddressData>;
  status?: Maybe<Scalars['String']>;
};

export type Encounter = {
  __typename?: 'Encounter';
  acknowledgedEstimateDisclaimer?: Maybe<Scalars['String']>;
  acknowledgedEstimateDisclaimerAt?: Maybe<Scalars['DateTime']>;
  actions: Array<EncounterDetailsGroupModel>;
  admissionType?: Maybe<Scalars['String']>;
  admitDateTime?: Maybe<Scalars['DateTime']>;
  admitReason?: Maybe<Scalars['String']>;
  admitSource?: Maybe<Scalars['String']>;
  admittingDoctor?: Maybe<Scalars['String']>;
  aggregateKey?: Maybe<Scalars['String']>;
  alerts?: Maybe<Array<EncounterAlert>>;
  arrivedNotes?: Maybe<Array<EncounterArrivedNotes>>;
  attendingDoctor?: Maybe<Scalars['String']>;
  auxiliaryData?: Maybe<Array<EncounterData>>;
  checksums?: Maybe<Array<EncounterChecksum>>;
  communication?: Maybe<EncounterCommunication>;
  communications?: Maybe<Array<EncounterCommunication>>;
  consumerNumber?: Maybe<Scalars['String']>;
  contactPoints: Array<ContactPoint>;
  correlationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Array<EncounterData>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  diagnoses?: Maybe<Array<Maybe<Diagnosis>>>;
  dischargeDateTime?: Maybe<Scalars['DateTime']>;
  doNotUseInsurances: Scalars['Boolean'];
  doctors?: Maybe<EncounterDoctor>;
  encounterBase?: Maybe<PatientBase>;
  encounterSource?: Maybe<Scalars['String']>;
  encounterState: Scalars['Int'];
  encounterStateAudit?: Maybe<Array<EncounterStateAudit>>;
  encounterUser?: Maybe<Scalars['String']>;
  engagements?: Maybe<Array<EncounterEngagement>>;
  estimate?: Maybe<Estimate>;
  estimates?: Maybe<Array<Estimate>>;
  events?: Maybe<Array<Maybe<EncounterEvent>>>;
  externalId: Scalars['String'];
  fileStreamDataFileId?: Maybe<Scalars['String']>;
  fillerAppointmentId?: Maybe<Scalars['String']>;
  financialClass?: Maybe<Scalars['String']>;
  formCompleted?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  guarantorBase?: Maybe<GuarantorBase>;
  hasEstimate?: Maybe<Scalars['Boolean']>;
  header: EncounterHeaderModel;
  hospitalService?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifiers?: Maybe<Array<EncounterIdentifier>>;
  insurance?: Maybe<EncounterInsurance>;
  insuranceActions: Array<EncounterDetailsGroupModel>;
  insurances?: Maybe<Array<EncounterInsurance>>;
  internalIdentifier: Scalars['String'];
  isNewEncounter: Scalars['Boolean'];
  isOnDemand: Scalars['Boolean'];
  isRteEligible: Scalars['Boolean'];
  language: Scalars['JSON'];
  location?: Maybe<Scalars['String']>;
  messageType?: Maybe<Scalars['String']>;
  orgRsfConfigs?: Maybe<Array<OrganizationRsfConfig>>;
  organization?: Maybe<Organization>;
  organizationExternalId: Scalars['String'];
  organizationId: Scalars['Int'];
  organizationLocation?: Maybe<OrganizationLocation>;
  organizationLocationId?: Maybe<Scalars['Int']>;
  patientBase?: Maybe<PatientMaster>;
  patientClass?: Maybe<Scalars['String']>;
  patientDocuments?: Maybe<PatientDocumentsHeaderModel>;
  patientIdentifiers?: Maybe<Array<EncounterPatientIdentifier>>;
  patientType?: Maybe<Scalars['String']>;
  paymentIsEligible?: Maybe<Scalars['Boolean']>;
  payments?: Maybe<Array<EncounterPayment>>;
  personnelResourceId?: Maybe<Scalars['String']>;
  personnelResourceName?: Maybe<Scalars['String']>;
  preadmitNumber?: Maybe<Scalars['String']>;
  preadmitNumber_Encrypted?: Maybe<Scalars['String']>;
  preferredFullName: Scalars['String'];
  primaryInsuranceBenefitStatus?: Maybe<BenefitStatus>;
  primaryService?: Maybe<Scalars['String']>;
  procedures?: Maybe<Array<EncounterProcedure>>;
  providerLocation?: Maybe<Scalars['JSON']>;
  providerName?: Maybe<Scalars['String']>;
  providerTin?: Maybe<Scalars['String']>;
  responsibleParty?: Maybe<Scalars['String']>;
  scheduledOn?: Maybe<Scalars['DateTime']>;
  searchData?: Maybe<Array<EncounterSearch>>;
  servicingFacility?: Maybe<Scalars['String']>;
  syncAddresses: Scalars['Boolean'];
  universalServiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitDescription?: Maybe<Scalars['String']>;
  visitNumber: Scalars['String'];
};

export type EncounterAlert = {
  __typename?: 'EncounterAlert';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounterId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  severity?: Maybe<Scalars['String']>;
  subLabel?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterArrivedNotes = {
  __typename?: 'EncounterArrivedNotes';
  checkinId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  modifiedDate?: Maybe<Scalars['String']>;
  noteId?: Maybe<Scalars['Float']>;
  noteType?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type EncounterChecksum = {
  __typename?: 'EncounterChecksum';
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounterId?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterCommunication = {
  __typename?: 'EncounterCommunication';
  accessExpires?: Maybe<Scalars['DateTime']>;
  alias: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  audit?: Maybe<Array<Maybe<EncounterCommunicationAudit>>>;
  channel?: Maybe<Scalars['String']>;
  communicationContext?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryAudits?: Maybe<Array<Maybe<EncounterCommunicationDeliveryAudit>>>;
  deliveryStatus?: Maybe<EncounterCommunicationDeliveryStatus>;
  deliveryStatusAttempts: Scalars['Float'];
  deliveryStatusFinalized: Scalars['Boolean'];
  deliveryStatusMaxAttempts: Scalars['Float'];
  deliveryStatusRequired: EncounterCommunicationDeliveryStatusRequired;
  destination?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  encounterId?: Maybe<Scalars['Float']>;
  estimateSessionId?: Maybe<Scalars['String']>;
  formSessionId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkExpires?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['Int']>;
  redirectToEncounterCommunicationId?: Maybe<Scalars['Float']>;
  sendDate?: Maybe<Scalars['DateTime']>;
  sent?: Maybe<Scalars['Boolean']>;
  type?: Maybe<EncounterCommunicationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterCommunicationAudit = {
  __typename?: 'EncounterCommunicationAudit';
  action?: Maybe<Scalars['String']>;
  authenticated?: Maybe<Scalars['Boolean']>;
  browser?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounterCommunicationId: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  ipAddress?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
};

export type EncounterCommunicationContextInput = {
  alias: Scalars['String'];
  communicationId?: InputMaybe<Scalars['Float']>;
  communicationType: Scalars['String'];
  consent: CommunicationConsentInput;
  delivery?: InputMaybe<EncounterCommunicationDeliveryInput>;
  destination: Scalars['String'];
  disableBlackout?: InputMaybe<Scalars['Boolean']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  encounterId: Scalars['Int'];
  estimateEnabled?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<CommunicationFilterInput>;
  formsEnabled?: InputMaybe<Scalars['Boolean']>;
  handler: Scalars['String'];
  lookupKey: Scalars['String'];
  paymentEnabled?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shouldSend?: InputMaybe<Scalars['Boolean']>;
  templateContext?: InputMaybe<Scalars['JSON']>;
  templateParams: TemplateParamsInput;
};

export type EncounterCommunicationDelivery = {
  __typename?: 'EncounterCommunicationDelivery';
  appointmendId?: Maybe<Scalars['String']>;
  messageGuid?: Maybe<Scalars['String']>;
  vendorAppointmentId?: Maybe<Scalars['String']>;
};

export type EncounterCommunicationDeliveryAudit = {
  __typename?: 'EncounterCommunicationDeliveryAudit';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryStatusReason: Scalars['String'];
  deliveryStatusResult: EncounterCommunicationDeliveryStatus;
  encounterCommunicationId: Scalars['Float'];
  id: Scalars['ID'];
  request: Scalars['JSON'];
  response: Scalars['JSON'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterCommunicationDeliveryInput = {
  appointmendId?: InputMaybe<Scalars['String']>;
  messageGuid?: InputMaybe<Scalars['String']>;
  vendorAppointmentId?: InputMaybe<Scalars['String']>;
};

export enum EncounterCommunicationDeliveryStatus {
  AttemptsExceeded = 'AttemptsExceeded',
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success',
  Unknown = 'Unknown'
}

export enum EncounterCommunicationDeliveryStatusRequired {
  None = 'None',
  Omnichannel = 'Omnichannel',
  Talksoft = 'Talksoft'
}

export enum EncounterCommunicationType {
  Estimate = 'Estimate',
  Registration = 'Registration',
  Survey = 'Survey'
}

export type EncounterCompleteForm = {
  __typename?: 'EncounterCompleteForm';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  formSessionId: Scalars['String'];
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['Int'];
};

export type EncounterData = {
  __typename?: 'EncounterData';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounterId: Scalars['Int'];
  id: Scalars['Int'];
  key: Scalars['String'];
  source: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['JSON'];
};

export type EncounterDetailsFieldCategory = {
  __typename?: 'EncounterDetailsFieldCategory';
  categoryOrder?: Maybe<Scalars['String']>;
  categoryTitle?: Maybe<Scalars['String']>;
};

export type EncounterDetailsFieldModel = {
  __typename?: 'EncounterDetailsFieldModel';
  action?: Maybe<Scalars['String']>;
  actionLabel?: Maybe<Scalars['String']>;
  category?: Maybe<EncounterDetailsFieldCategory>;
  class?: Maybe<Scalars['String']>;
  copyToClipboard?: Maybe<Scalars['Boolean']>;
  payload?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleDescription?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EncounterDetailsGroupModel = {
  __typename?: 'EncounterDetailsGroupModel';
  action?: Maybe<Scalars['String']>;
  actionLabel?: Maybe<Scalars['String']>;
  details?: Maybe<EncounterDetailsFieldModel>;
  fields: Array<EncounterDetailsFieldModel>;
  payload?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleDescription?: Maybe<Scalars['String']>;
};

export type EncounterDoctor = {
  __typename?: 'EncounterDoctor';
  createdAt: Scalars['DateTime'];
  doctorId?: Maybe<Scalars['String']>;
  doctorType: DoctorType;
  encounterId: Scalars['Int'];
  id: Scalars['ID'];
  nameFamily?: Maybe<Scalars['String']>;
  nameGiven?: Maybe<Scalars['String']>;
  nameMiddle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EncounterEngagement = {
  __typename?: 'EncounterEngagement';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentStatus?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounter: Encounter;
  encounterId: Scalars['Int'];
  engagementIdentifier: Scalars['String'];
  events: Array<EncounterEngagementEvent>;
  id: Scalars['ID'];
  initFailureReason: Scalars['String'];
  initialized: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterEngagementEvent = {
  __typename?: 'EncounterEngagementEvent';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  engagement: EncounterEngagement;
  engagementId: Scalars['Int'];
  eventType: EncounterEngagementEventType;
  id: Scalars['ID'];
  sourceEvent: Scalars['JSON'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum EncounterEngagementEventType {
  ClientStop = 'ClientStop',
  EmailBounced = 'EmailBounced',
  EmailClicked = 'EmailClicked',
  EmailDelivered = 'EmailDelivered',
  EmailOpened = 'EmailOpened',
  EmailRejected = 'EmailRejected',
  EmailSent = 'EmailSent',
  EmailSubscribed = 'EmailSubscribed',
  EmailUnsubscribed = 'EmailUnsubscribed',
  EngagementRestarted = 'EngagementRestarted',
  EngagementStarted = 'EngagementStarted',
  FailedAuth = 'FailedAuth',
  FailedClicked = 'FailedClicked',
  FailedIncomplete = 'FailedIncomplete',
  FailedNoResponse = 'FailedNoResponse',
  GoalPartiallyMet = 'GoalPartiallyMet',
  IvrResponseCollected = 'IVRResponseCollected',
  IvrAnswerConfirmed = 'IvrAnswerConfirmed',
  IvrBusy = 'IvrBusy',
  IvrCancelled = 'IvrCancelled',
  IvrFailed = 'IvrFailed',
  IvrGreetingHeard = 'IvrGreetingHeard',
  IvrMachineAnswered = 'IvrMachineAnswered',
  IvrNoAnswer = 'IvrNoAnswer',
  IvrOptOut = 'IvrOptOut',
  IvrResponseReceived = 'IvrResponseReceived',
  LinkClicked = 'LinkClicked',
  OptOut = 'OptOut',
  PrintJourney = 'PrintJourney',
  PrintUndeliverable = 'PrintUndeliverable',
  SmsClicked = 'SmsClicked',
  SmsDelivered = 'SmsDelivered',
  SmsSent = 'SmsSent',
  SmsSubscribed = 'SmsSubscribed',
  SmsUndelivered = 'SmsUndelivered',
  SmsUnsubscribed = 'SmsUnsubscribed',
  Success = 'Success',
  TouchCanceled = 'TouchCanceled',
  TouchDelayed = 'TouchDelayed',
  TouchInitiated = 'TouchInitiated',
  TouchInitiationFailed = 'TouchInitiationFailed',
  TouchQueued = 'TouchQueued',
  Undeliverable = 'Undeliverable'
}

export type EncounterEngagementsResponse = {
  __typename?: 'EncounterEngagementsResponse';
  lastRow?: Maybe<Scalars['Float']>;
  rows?: Maybe<Array<Encounter>>;
};

export type EncounterEvent = {
  __typename?: 'EncounterEvent';
  correlationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  encounterId?: Maybe<Scalars['Float']>;
  entityReferenceKey?: Maybe<Scalars['String']>;
  eventAction?: Maybe<EventAction>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSON']>;
  organizationId?: Maybe<Scalars['Float']>;
  payload?: Maybe<Scalars['JSON']>;
  payload_Encrypted?: Maybe<Scalars['JSON']>;
  sender?: Maybe<Scalars['String']>;
  sourceCorrelationId?: Maybe<Scalars['String']>;
};

export type EncounterHeaderActionModel = {
  __typename?: 'EncounterHeaderActionModel';
  action?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

export type EncounterHeaderFieldModel = {
  __typename?: 'EncounterHeaderFieldModel';
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EncounterHeaderModel = {
  __typename?: 'EncounterHeaderModel';
  actions?: Maybe<Array<EncounterHeaderActionModel>>;
  fields: Array<EncounterHeaderFieldModel>;
};

export type EncounterIdentifier = {
  __typename?: 'EncounterIdentifier';
  encounterId: Scalars['Int'];
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_Encrypted?: Maybe<Scalars['String']>;
};

export type EncounterInsurance = {
  __typename?: 'EncounterInsurance';
  allowFlip: Scalars['Boolean'];
  benefit?: Maybe<EncounterInsuranceBenefit>;
  benefits?: Maybe<Array<EncounterInsuranceBenefit>>;
  carrierId?: Maybe<Scalars['String']>;
  carrierName?: Maybe<Scalars['String']>;
  converageType?: Maybe<Scalars['String']>;
  copayOverrides?: Maybe<Array<PlanMasterCopay>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfServiceBegin?: Maybe<Scalars['DateTime']>;
  dateOfServiceEnd?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedAtHash: Scalars['String'];
  encounterId: Scalars['Int'];
  groupName?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  hicNumber?: Maybe<Scalars['String']>;
  hicNumber_Encrypted?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageBack?: Maybe<Scalars['String']>;
  imageFront?: Maybe<Scalars['String']>;
  insuredDob?: Maybe<Scalars['DateTime']>;
  insuredDob_Encrypted?: Maybe<Scalars['String']>;
  insuredNameFamily?: Maybe<Scalars['String']>;
  insuredNameGiven?: Maybe<Scalars['String']>;
  insuredNameMiddle?: Maybe<Scalars['String']>;
  insuredNamePrefix?: Maybe<Scalars['String']>;
  insuredNameSuffix?: Maybe<Scalars['String']>;
  insuredRelationship?: Maybe<Scalars['String']>;
  insuredSex?: Maybe<Scalars['String']>;
  insuredSsn?: Maybe<Scalars['String']>;
  insuredSsn_Encrypted?: Maybe<Scalars['String']>;
  isMemberSubscriber?: Maybe<Scalars['Boolean']>;
  isRteEligible: Scalars['Boolean'];
  medicaidCaseNumber?: Maybe<Scalars['String']>;
  medicaidCaseNumber_Encrypted?: Maybe<Scalars['String']>;
  memberNumber?: Maybe<Scalars['String']>;
  memberNumber_Encrypted?: Maybe<Scalars['String']>;
  payerId?: Maybe<Scalars['String']>;
  payerIsMapped: Scalars['Boolean'];
  payerName?: Maybe<Scalars['String']>;
  planEffectiveDate?: Maybe<Scalars['DateTime']>;
  planExpirationDate?: Maybe<Scalars['DateTime']>;
  planId?: Maybe<Scalars['String']>;
  planMasterId?: Maybe<Scalars['Float']>;
  planName?: Maybe<Scalars['String']>;
  planNameEhr?: Maybe<Scalars['String']>;
  planNamePayer?: Maybe<Scalars['String']>;
  planNameProvider?: Maybe<Scalars['String']>;
  planNetwork?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  policyNumber_Encrypted?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  source: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  studentIndicator?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendorGroupName?: Maybe<Scalars['String']>;
  vendorGroupNumber?: Maybe<Scalars['String']>;
  vendorInsuredNameFamily?: Maybe<Scalars['String']>;
  vendorInsuredNameGiven?: Maybe<Scalars['String']>;
  vendorInsuredNameMiddle?: Maybe<Scalars['String']>;
  vendorInsuredNamePrefix?: Maybe<Scalars['String']>;
  vendorInsuredNameSuffix?: Maybe<Scalars['String']>;
  vendorMemberNumber?: Maybe<Scalars['String']>;
  vendorPlanId?: Maybe<Scalars['String']>;
  vendorPolicyNumber?: Maybe<Scalars['String']>;
};

export type EncounterInsuranceBenefit = {
  __typename?: 'EncounterInsuranceBenefit';
  alerts?: Maybe<Array<InsuranceBenefitAlert>>;
  benefit271?: Maybe<Scalars['String']>;
  benefit271HiDefJson?: Maybe<Scalars['String']>;
  benefitStatus?: Maybe<BenefitStatus>;
  benefitStatusDetails?: Maybe<Scalars['String']>;
  benefitText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discrepancies?: Maybe<Array<Maybe<InsuranceDiscrepancy>>>;
  id: Scalars['ID'];
  inNetworkBenefit?: Maybe<Benefit>;
  insuranceId?: Maybe<Scalars['Int']>;
  outNetworkBenefit?: Maybe<Benefit>;
  policyInfo?: Maybe<InsurancePolicyInfo>;
  vendorRequestData?: Maybe<Scalars['JSON']>;
  vendorResponse?: Maybe<RteVendorResponse>;
};

export type EncounterJobType = {
  __typename?: 'EncounterJobType';
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type EncounterPatientIdentifier = {
  __typename?: 'EncounterPatientIdentifier';
  encounterId: Scalars['Int'];
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_Encrypted?: Maybe<Scalars['String']>;
};

export type EncounterPayment = {
  __typename?: 'EncounterPayment';
  accountNumber: Scalars['String'];
  amount: Scalars['Float'];
  confirmationNumber: Scalars['String'];
  consumerNumber: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  entryMode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastEstimateId?: Maybe<Scalars['Float']>;
  lastManualEstimateId?: Maybe<Scalars['Float']>;
  lastSystemEstimateId?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentSource?: Maybe<Scalars['String']>;
  transactionDate: Scalars['DateTime'];
  transactionId: Scalars['Int'];
  transactionStatus: Scalars['String'];
  transactionType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterProcedure = {
  __typename?: 'EncounterProcedure';
  amount?: Maybe<Scalars['Float']>;
  chargeMaster?: Maybe<ChargeMaster>;
  chargeMasterId?: Maybe<Scalars['Int']>;
  chargeMasterMnemonic?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  diagnosisCodes?: Maybe<Array<Scalars['String']>>;
  encounterId: Scalars['Int'];
  id: Scalars['ID'];
  manualEntry: Scalars['Boolean'];
  orderNumber: Scalars['String'];
  organizationLocationId?: Maybe<Scalars['Int']>;
  procedureCode?: Maybe<Scalars['String']>;
  procedureDate?: Maybe<Scalars['DateTime']>;
  procedureDisplayName?: Maybe<Scalars['String']>;
  procedureGroupId?: Maybe<Scalars['Int']>;
  procedureGroupProcedureId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  rsProcedureMaster?: Maybe<RsProcedureMaster>;
  rsRevenueCodeMaster?: Maybe<RsRevenueCode>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterSearch = {
  __typename?: 'EncounterSearch';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounterId: Scalars['Int'];
  id: Scalars['Int'];
  key: Scalars['String'];
  organizationId: Scalars['Int'];
  searchTerm: Scalars['String'];
  sortDate: Scalars['DateTime'];
  sortTerm: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EncounterSearchResults = {
  __typename?: 'EncounterSearchResults';
  data: Array<Encounter>;
  total: Scalars['Int'];
};

export type EncounterStateAudit = {
  __typename?: 'EncounterStateAudit';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['DateTime']>;
  encounterId: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  modifiedBy?: Maybe<Scalars['DateTime']>;
  toState: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EngagementResponse = {
  __typename?: 'EngagementResponse';
  lastRow?: Maybe<Scalars['Float']>;
  rows?: Maybe<Array<EncounterEngagement>>;
};

export type EngagementSortArgs = {
  colId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type Estimate = {
  __typename?: 'Estimate';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']>;
  addresses?: Maybe<Array<Address>>;
  alertMessage?: Maybe<Array<Scalars['String']>>;
  appliedToDeductible?: Maybe<Scalars['Float']>;
  attachments?: Maybe<Array<EstimateAttachment>>;
  auxiliaryData?: Maybe<Scalars['JSON']>;
  category?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copay?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  dedFamMaxAmount?: Maybe<Scalars['Float']>;
  dedFamRemainingAfterEstimate?: Maybe<Scalars['Float']>;
  dedIndMaxAmount?: Maybe<Scalars['Float']>;
  dedIndRemainingAfterEstimate?: Maybe<Scalars['Float']>;
  dedRemainingFamAmount?: Maybe<Scalars['Float']>;
  dedRemainingIndAmount?: Maybe<Scalars['Float']>;
  deductibleMet?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  diagnoses?: Maybe<Array<Diagnosis>>;
  encounter?: Maybe<Encounter>;
  estimateLog?: Maybe<EstimateLog>;
  estimateLogId?: Maybe<Scalars['Int']>;
  estimateNumber?: Maybe<Scalars['String']>;
  estimateRenderConfigDeltas?: Maybe<Array<EstimateRenderConfigDelta>>;
  estimateScore?: Maybe<Array<EstimateScore>>;
  estimateScores?: Maybe<Array<EstimateScore>>;
  estimateSession?: Maybe<EstimateSession>;
  estimateSessionId?: Maybe<Scalars['Int']>;
  estimateStatement?: Maybe<EstimateStatement>;
  estimateStatementId?: Maybe<Scalars['Int']>;
  estimateStatus?: Maybe<EstimateStatus>;
  estimateStatusId?: Maybe<Scalars['Int']>;
  groupName?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  hasBenefits?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isSelfPay?: Maybe<Scalars['Boolean']>;
  oopFamMaxAmount?: Maybe<Scalars['Float']>;
  oopFamMaxMet?: Maybe<Scalars['Boolean']>;
  oopFamUsedAmount?: Maybe<Scalars['Float']>;
  oopIndMaxAmount?: Maybe<Scalars['Float']>;
  oopIndMaxMet?: Maybe<Scalars['Boolean']>;
  oopIndUsedAmount?: Maybe<Scalars['Float']>;
  outOfNetwork?: Maybe<Scalars['Boolean']>;
  patientDob?: Maybe<Scalars['DateTime']>;
  patientMrn?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  payerId?: Maybe<Scalars['String']>;
  payerMasterId?: Maybe<Scalars['Int']>;
  payerName?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planMasterId?: Maybe<Scalars['Int']>;
  planType?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  primaryService?: Maybe<Scalars['String']>;
  primaryServiceScheduled?: Maybe<Scalars['DateTime']>;
  related?: Maybe<Scalars['JSON']>;
  selfpayDiscounts?: Maybe<EstimateSelfpayDiscount>;
  serviceGroups?: Maybe<Array<Maybe<EstimateServiceGroup>>>;
  source: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  totalAllowedAmount?: Maybe<Scalars['Float']>;
  totalPatientResponsibility?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitCount?: Maybe<Scalars['Int']>;
  visitNumber?: Maybe<Scalars['String']>;
};

export type EstimateAction = {
  __typename?: 'EstimateAction';
  icon?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<LinkModel>;
};

export type EstimateAmountsInput = {
  appliedToDeductible?: InputMaybe<Scalars['Float']>;
  dedFamMaxAmount?: InputMaybe<Scalars['Float']>;
  dedFamRemainingAfterEstimate?: InputMaybe<Scalars['Float']>;
  dedIndMaxAmount?: InputMaybe<Scalars['Float']>;
  dedIndRemainingAfterEstimate?: InputMaybe<Scalars['Float']>;
  dedRemainingFamAmount?: InputMaybe<Scalars['Float']>;
  dedRemainingIndAmount?: InputMaybe<Scalars['Float']>;
  deductibleMet?: InputMaybe<Scalars['Boolean']>;
  hasBenefits?: InputMaybe<Scalars['Boolean']>;
  isSelfPay?: InputMaybe<Scalars['Boolean']>;
  oopFamMaxAmount?: InputMaybe<Scalars['Float']>;
  oopFamMaxMet?: InputMaybe<Scalars['Boolean']>;
  oopFamUsedAmount?: InputMaybe<Scalars['Float']>;
  oopIndMaxAmount?: InputMaybe<Scalars['Float']>;
  oopIndMaxMet?: InputMaybe<Scalars['Boolean']>;
  oopIndUsedAmount?: InputMaybe<Scalars['Float']>;
  outOfNetwork?: InputMaybe<Scalars['Boolean']>;
  totalAllowedAmount?: InputMaybe<Scalars['Float']>;
  totalPatientResponsibility?: InputMaybe<Scalars['Float']>;
};

export type EstimateAttachment = {
  __typename?: 'EstimateAttachment';
  accountId?: Maybe<Scalars['Int']>;
  content?: Maybe<EstimateAttachmentContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EstimateAttachmentContentType = {
  password?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EstimateAttachmentInput = {
  embedded?: InputMaybe<Array<InputMaybe<EmbeddedEstimateAttachmentInput>>>;
  json?: InputMaybe<Array<InputMaybe<JsonEstimateAttachmentInput>>>;
  pdf?: InputMaybe<Array<InputMaybe<PdfEstimateAttachmentInput>>>;
};

export type EstimateChanged = {
  __typename?: 'EstimateChanged';
  estimate?: Maybe<EstimateRenderData>;
  eventAction?: Maybe<EventAction>;
  eventType?: Maybe<EventType>;
};

export type EstimateConfig = {
  __typename?: 'EstimateConfig';
  accountId?: Maybe<Scalars['Int']>;
  appName: Scalars['String'];
  config?: Maybe<Scalars['JSON']>;
  configName: Scalars['String'];
  id: Scalars['ID'];
  language?: Maybe<Scalars['JSON']>;
  provider: Scalars['String'];
  rules?: Maybe<Scalars['JSON']>;
  transformer: Scalars['String'];
};

export type EstimateGroupLineModel = {
  __typename?: 'EstimateGroupLineModel';
  class?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EstimateGroupModel = {
  __typename?: 'EstimateGroupModel';
  diagnosisCodes?: Maybe<Array<Scalars['String']>>;
  headerVisible?: Maybe<Scalars['Boolean']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  procedureCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalVisible?: Maybe<Scalars['Boolean']>;
  totals?: Maybe<Array<EstimateGroupLineModel>>;
};

export type EstimateHeaderAction = {
  __typename?: 'EstimateHeaderAction';
  action?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type EstimateInsuranceInput = {
  groupName?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  payerId?: InputMaybe<Scalars['String']>;
  payerName?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  policyNumber?: InputMaybe<Scalars['String']>;
};

export type EstimateLog = {
  __typename?: 'EstimateLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Array<Maybe<EstimateLogDetail>>>;
  estimateId?: Maybe<Scalars['Int']>;
  facts?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  summary?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EstimateLogDetail = {
  __typename?: 'EstimateLogDetail';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateLogId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  type?: Maybe<EstimateLogDetailType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['JSON']>;
};

export enum EstimateLogDetailType {
  Error = 'ERROR',
  Fact = 'FACT',
  Info = 'INFO',
  TimestampEnd = 'TIMESTAMP_END',
  TimestampStart = 'TIMESTAMP_START',
  Warning = 'WARNING'
}

export type EstimateProcedure = {
  __typename?: 'EstimateProcedure';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EstimateProviderGroupModel = {
  __typename?: 'EstimateProviderGroupModel';
  groupingKey?: Maybe<Scalars['String']>;
  headerVisible?: Maybe<Scalars['Boolean']>;
  services?: Maybe<Array<EstimateGroupModel>>;
  total?: Maybe<Array<EstimateGroupLineModel>>;
  totalVisible?: Maybe<Scalars['Boolean']>;
};

export type EstimateRenderConfigDelta = {
  __typename?: 'EstimateRenderConfigDelta';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  diff?: Maybe<Scalars['JSON']>;
  estimateId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EstimateRenderData = {
  __typename?: 'EstimateRenderData';
  accountExternalReferenceId?: Maybe<Scalars['String']>;
  alertMessage?: Maybe<Array<Scalars['String']>>;
  attachmentPdfPageCount?: Maybe<Scalars['Float']>;
  attachments?: Maybe<Array<Maybe<EstimateAttachment>>>;
  auxiliaryData?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  estimateConfig?: Maybe<Scalars['JSON']>;
  estimateNumber?: Maybe<Scalars['String']>;
  estimateScore?: Maybe<Scalars['String']>;
  estimateSession?: Maybe<EstimateSession>;
  estimateSessionId?: Maybe<Scalars['String']>;
  estimateStatus?: Maybe<EstimateStatus>;
  footer?: Maybe<Scalars['String']>;
  headerActions?: Maybe<Array<EstimateHeaderAction>>;
  id?: Maybe<Scalars['Float']>;
  patientName?: Maybe<Scalars['String']>;
  pdfData?: Maybe<Scalars['String']>;
  pdfPageCount?: Maybe<Scalars['Float']>;
  primaryServiceLocation?: Maybe<ProviderLocation>;
  procedureDetails?: Maybe<Array<EstimateProcedure>>;
  procedures?: Maybe<Array<Scalars['String']>>;
  providerNpi?: Maybe<Scalars['String']>;
  summary?: Maybe<EstimateSummary>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EstimateRetryArgs = {
  retryDelay?: InputMaybe<Scalars['Float']>;
  retryMax?: InputMaybe<Scalars['Float']>;
};

export type EstimateScore = {
  __typename?: 'EstimateScore';
  accountId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateId?: Maybe<Scalars['Int']>;
  estimateLog?: Maybe<EstimateLog>;
  id: Scalars['ID'];
  score?: Maybe<Scalars['Int']>;
  scoringAlgorithmVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EstimateSection = {
  __typename?: 'EstimateSection';
  class?: Maybe<Scalars['String']>;
  colSpan?: Maybe<Scalars['String']>;
  colStart?: Maybe<Scalars['String']>;
  column?: Maybe<Scalars['Int']>;
  each?: Maybe<Array<EstimateSectionLoop>>;
  hasIcon?: Maybe<Scalars['Boolean']>;
  iconPlaceholderClass?: Maybe<Scalars['String']>;
  items?: Maybe<Array<EstimateSectionItem>>;
  sections?: Maybe<Array<EstimateSection>>;
  span?: Maybe<Scalars['String']>;
};

export type EstimateSectionIcon = {
  __typename?: 'EstimateSectionIcon';
  color?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
};

export type EstimateSectionItem = {
  __typename?: 'EstimateSectionItem';
  class?: Maybe<Scalars['String']>;
  colSpan?: Maybe<Scalars['String']>;
  colStart?: Maybe<Scalars['String']>;
  column?: Maybe<Scalars['Int']>;
  each?: Maybe<Array<EstimateSectionLoop>>;
  hasIcon?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<EstimateSectionIcon>;
  iconPlaceholderClass?: Maybe<Scalars['String']>;
  items?: Maybe<Array<EstimateSectionItem>>;
  sections?: Maybe<Array<EstimateSection>>;
  span?: Maybe<Scalars['String']>;
  text?: Maybe<EstimateSectionText>;
};

export type EstimateSectionLoop = {
  __typename?: 'EstimateSectionLoop';
  class?: Maybe<Scalars['String']>;
  colSpan?: Maybe<Scalars['String']>;
  colStart?: Maybe<Scalars['String']>;
  column?: Maybe<Scalars['Int']>;
  datakey: Scalars['String'];
  each?: Maybe<Array<EstimateSectionLoop>>;
  hasIcon?: Maybe<Scalars['Boolean']>;
  iconPlaceholderClass?: Maybe<Scalars['String']>;
  items?: Maybe<Array<EstimateSectionItem>>;
  sections?: Maybe<Array<EstimateSection>>;
  span?: Maybe<Scalars['String']>;
};

export type EstimateSectionText = {
  __typename?: 'EstimateSectionText';
  class?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type EstimateSelfpayDiscount = {
  __typename?: 'EstimateSelfpayDiscount';
  accountSelfpay: Estimate;
  accountSelfpayId: Scalars['Int'];
  discountApplied: Scalars['Int'];
  discountPercentage: Scalars['Int'];
  estimate: Estimate;
  estimateId: Scalars['Int'];
  id: Scalars['ID'];
  total: Scalars['Int'];
};

export type EstimateService = {
  __typename?: 'EstimateService';
  alerts?: Maybe<Scalars['JSON']>;
  allowedAmount?: Maybe<Scalars['Float']>;
  allowedRate?: Maybe<Scalars['Float']>;
  appliedToDeductible?: Maybe<Scalars['Float']>;
  appliedToSpendingAccount?: Maybe<Scalars['Float']>;
  burnsDeductible?: Maybe<BenefitBurndown>;
  burnsOutOfPocket?: Maybe<BenefitBurndown>;
  cashDiscountFlatAmount?: Maybe<Scalars['Float']>;
  cashDiscountPercent?: Maybe<Scalars['Int']>;
  coinsuranceAmount?: Maybe<Scalars['Float']>;
  coinsuranceApplies?: Maybe<Scalars['Boolean']>;
  coinsurancePercent?: Maybe<Scalars['Float']>;
  copayAmount?: Maybe<Scalars['Float']>;
  copayApplies?: Maybe<Scalars['Boolean']>;
  costShareCappedAmount?: Maybe<Scalars['Float']>;
  costSharingAmount?: Maybe<Scalars['Float']>;
  coveredServiceLimitApplied?: Maybe<Scalars['Boolean']>;
  coveredServiceLimitCoverageLevel?: Maybe<Scalars['String']>;
  coveredServiceLimitHasRemaining?: Maybe<Scalars['Boolean']>;
  coveredServiceLimitReason?: Maybe<Scalars['String']>;
  coveredServiceLimitRemaining?: Maybe<Scalars['Float']>;
  coveredServiceLimitTotal?: Maybe<Scalars['Float']>;
  deductibleApplies?: Maybe<Scalars['Boolean']>;
  deductibleIgnored?: Maybe<Scalars['Boolean']>;
  deductibleMet?: Maybe<Scalars['Boolean']>;
  diagnosisCodes?: Maybe<Array<Scalars['String']>>;
  grossAmount?: Maybe<Scalars['Float']>;
  groupingKey?: Maybe<Scalars['String']>;
  hasChargeMaster?: Maybe<Scalars['Boolean']>;
  hasContract?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isHospitalCharge?: Maybe<Scalars['Boolean']>;
  isProfessionalCharge?: Maybe<Scalars['Boolean']>;
  location?: Maybe<ProviderLocation>;
  oopFamMaxMet?: Maybe<Scalars['Boolean']>;
  oopFamMaxRemaining?: Maybe<Scalars['Float']>;
  oopFamUsedAmount?: Maybe<Scalars['Float']>;
  oopIndMaxMet?: Maybe<Scalars['Boolean']>;
  oopIndMaxRemaining?: Maybe<Scalars['Float']>;
  oopIndUsedAmount?: Maybe<Scalars['Float']>;
  oopMaxRemaining?: Maybe<Scalars['Float']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  procedureCode?: Maybe<Scalars['String']>;
  procedureDisplayName?: Maybe<Scalars['String']>;
  providerNpi?: Maybe<Scalars['String']>;
  serviceCode?: Maybe<Scalars['String']>;
  serviceGroupId?: Maybe<Scalars['Int']>;
  servicesToSchedule?: Maybe<Scalars['JSON']>;
  spendingAccountRemaining?: Maybe<Scalars['Float']>;
  spendingAccountType?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['Float']>;
};

export type EstimateServiceGroup = {
  __typename?: 'EstimateServiceGroup';
  alerts?: Maybe<Scalars['JSON']>;
  estimateId?: Maybe<Scalars['Int']>;
  groupMode?: Maybe<Scalars['Int']>;
  groupType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  location?: Maybe<ProviderLocation>;
  npi?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<EstimateService>>>;
  tin?: Maybe<Scalars['String']>;
};

export type EstimateServiceGroupInput = {
  alerts?: InputMaybe<Scalars['JSON']>;
  estimateId?: InputMaybe<Scalars['Int']>;
  groupMode?: InputMaybe<Scalars['Int']>;
  groupType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<ProviderLocationInput>;
  npi?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<InputMaybe<EstimateServiceInput>>>;
  tin?: InputMaybe<Scalars['String']>;
};

export type EstimateServiceGroupModel = {
  __typename?: 'EstimateServiceGroupModel';
  groupType?: Maybe<Scalars['String']>;
  providerGroups?: Maybe<Array<EstimateProviderGroupModel>>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  total?: Maybe<EstimateGroupLineModel>;
};

export type EstimateServiceInput = {
  alerts?: InputMaybe<Scalars['JSON']>;
  allowedAmount?: InputMaybe<Scalars['Float']>;
  allowedRate?: InputMaybe<Scalars['Float']>;
  appliedToDeductible?: InputMaybe<Scalars['Float']>;
  appliedToSpendingAccount?: InputMaybe<Scalars['Float']>;
  burnsDeductible?: InputMaybe<BenefitBurndownInput>;
  burnsOutOfPocket?: InputMaybe<BenefitBurndownInput>;
  cashDiscountFlatAmount?: InputMaybe<Scalars['Float']>;
  cashDiscountPercent?: InputMaybe<Scalars['Int']>;
  coinsuranceAmount?: InputMaybe<Scalars['Float']>;
  coinsuranceApplies?: InputMaybe<Scalars['Boolean']>;
  coinsurancePercent?: InputMaybe<Scalars['Float']>;
  copayAmount?: InputMaybe<Scalars['Float']>;
  copayApplies?: InputMaybe<Scalars['Boolean']>;
  costShareCappedAmount?: InputMaybe<Scalars['Float']>;
  costSharingAmount?: InputMaybe<Scalars['Float']>;
  coveredServiceLimitApplied?: InputMaybe<Scalars['Boolean']>;
  coveredServiceLimitCoverageLevel?: InputMaybe<Scalars['String']>;
  coveredServiceLimitHasRemaining?: InputMaybe<Scalars['Boolean']>;
  coveredServiceLimitReason?: InputMaybe<Scalars['String']>;
  coveredServiceLimitRemaining?: InputMaybe<Scalars['Float']>;
  coveredServiceLimitTotal?: InputMaybe<Scalars['Float']>;
  deductibleApplies?: InputMaybe<Scalars['Boolean']>;
  deductibleIgnored?: InputMaybe<Scalars['Boolean']>;
  deductibleMet?: InputMaybe<Scalars['Boolean']>;
  diagnosisCodes?: InputMaybe<Array<Scalars['String']>>;
  grossAmount?: InputMaybe<Scalars['Float']>;
  groupingKey?: InputMaybe<Scalars['String']>;
  hasChargeMaster?: InputMaybe<Scalars['Boolean']>;
  hasContract?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isHospitalCharge?: InputMaybe<Scalars['Boolean']>;
  isProfessionalCharge?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<ProviderLocationInput>;
  oopFamMaxMet?: InputMaybe<Scalars['Boolean']>;
  oopFamMaxRemaining?: InputMaybe<Scalars['Float']>;
  oopFamUsedAmount?: InputMaybe<Scalars['Float']>;
  oopIndMaxMet?: InputMaybe<Scalars['Boolean']>;
  oopIndMaxRemaining?: InputMaybe<Scalars['Float']>;
  oopIndUsedAmount?: InputMaybe<Scalars['Float']>;
  oopMaxRemaining?: InputMaybe<Scalars['Float']>;
  patientResponsibility?: InputMaybe<Scalars['Float']>;
  procedureCode?: InputMaybe<Scalars['String']>;
  procedureDisplayName?: InputMaybe<Scalars['String']>;
  providerNpi?: InputMaybe<Scalars['String']>;
  serviceCode?: InputMaybe<Scalars['String']>;
  serviceGroupId?: InputMaybe<Scalars['Int']>;
  servicesToSchedule?: InputMaybe<Scalars['JSON']>;
  spendingAccountRemaining?: InputMaybe<Scalars['Float']>;
  spendingAccountType?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['Float']>;
};

export type EstimateSession = {
  __typename?: 'EstimateSession';
  accountId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimate?: Maybe<Estimate>;
  estimateId?: Maybe<Scalars['Int']>;
  externalReferenceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  manualEstimateReason?: Maybe<Scalars['JSON']>;
  referenceIds?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EstimateSettings = {
  __typename?: 'EstimateSettings';
  report?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
};

export type EstimateStatement = {
  __typename?: 'EstimateStatement';
  accountId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimate?: Maybe<Estimate>;
  estimateId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type EstimateStatus = {
  __typename?: 'EstimateStatus';
  copayOnly?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateId?: Maybe<Scalars['Int']>;
  hasCdm?: Maybe<Scalars['Boolean']>;
  hasContract?: Maybe<Scalars['Boolean']>;
  hasRte?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  reasonFriendly?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EstimateStatusInput = {
  copayOnly?: InputMaybe<Scalars['Boolean']>;
  estimateId?: InputMaybe<Scalars['Int']>;
  hasCdm?: InputMaybe<Scalars['Boolean']>;
  hasContract?: InputMaybe<Scalars['Boolean']>;
  hasRte?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  reasonFriendly?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
};

export type EstimateSummary = {
  __typename?: 'EstimateSummary';
  amount?: Maybe<Scalars['Float']>;
  responsibility?: Maybe<EstimateGroupLineModel>;
  showBenefitDisclaimer?: Maybe<Scalars['Boolean']>;
  totals?: Maybe<Array<EstimateGroupModel>>;
};

export type EventAction = {
  __typename?: 'EventAction';
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type EventType = {
  __typename?: 'EventType';
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GenericRequestLog = {
  __typename?: 'GenericRequestLog';
  application: Scalars['String'];
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  headers?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  method: Scalars['String'];
  requestType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type GuarantorBase = {
  __typename?: 'GuarantorBase';
  addresses?: Maybe<Array<Address>>;
  contactPoints?: Maybe<Array<ContactPoint>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfBirth_Encrypted?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Email>>;
  ethnicity?: Maybe<Scalars['String']>;
  guarantorNumber?: Maybe<Scalars['String']>;
  nameFamily?: Maybe<Scalars['String']>;
  nameGiven?: Maybe<Scalars['String']>;
  nameMiddle?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  race?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  ssn_Encrypted?: Maybe<Scalars['String']>;
};

export type HrefModel = {
  __typename?: 'HrefModel';
  Type?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
};

export type InsuranceAdditionalPolicyInfo = {
  __typename?: 'InsuranceAdditionalPolicyInfo';
  coinsuranceIPXRAYLAB?: Maybe<Scalars['Float']>;
  coinsuranceRMBOARD?: Maybe<Scalars['Float']>;
  hospiceEndDate?: Maybe<Scalars['DateTime']>;
  hospiceStartDate?: Maybe<Scalars['DateTime']>;
  inNetworkErCopay?: Maybe<Scalars['Float']>;
  inNetworkInpatientCopay?: Maybe<Scalars['Float']>;
  inNetworkOutpatientCopay?: Maybe<Scalars['Float']>;
  insuranceType?: Maybe<Scalars['String']>;
  physicianCopayFamilyPractice?: Maybe<Scalars['Float']>;
  physicianCopaySpecialist?: Maybe<Scalars['Float']>;
  planNumber?: Maybe<Scalars['String']>;
  spendDown?: Maybe<Scalars['String']>;
  spendDownDescription?: Maybe<Scalars['String']>;
  unableToDeterminePrimaryContactPoint?: Maybe<UnableToDetermineContactPointInfo>;
  unableToDetermineSecondaryContactPoint?: Maybe<UnableToDetermineContactPointInfo>;
  unableToDetermineTertiaryContactPoint?: Maybe<UnableToDetermineContactPointInfo>;
};

export type InsuranceBenefit = {
  __typename?: 'InsuranceBenefit';
  alerts?: Maybe<Array<Maybe<InsuranceBenefitAlert>>>;
  benefitStatus?: Maybe<BenefitStatus>;
  benefitStatusDetails?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discrepancies?: Maybe<Array<Maybe<InsuranceDiscrepancy>>>;
  id: Scalars['ID'];
  inNetworkBenefit?: Maybe<Benefit>;
  insuranceId?: Maybe<Scalars['Int']>;
  outNetworkBenefit?: Maybe<Benefit>;
  policyInfo?: Maybe<InsurancePolicyInfo>;
};

export type InsuranceBenefitAlert = {
  __typename?: 'InsuranceBenefitAlert';
  alertAdditionalDescription?: Maybe<Scalars['String']>;
  alertMaster?: Maybe<AlertMaster>;
  id: Scalars['ID'];
};

export type InsuranceDiscrepancy = {
  __typename?: 'InsuranceDiscrepancy';
  sourceField?: Maybe<Scalars['String']>;
  sourceValue?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  vendorField?: Maybe<Scalars['String']>;
  vendorValue?: Maybe<Scalars['String']>;
};

export type InsurancePolicyInfo = {
  __typename?: 'InsurancePolicyInfo';
  additionalInfo?: Maybe<InsuranceAdditionalPolicyInfo>;
  insuredDob?: Maybe<Scalars['DateTime']>;
  insuredNameGiven?: Maybe<Scalars['String']>;
  insuredNameLast?: Maybe<Scalars['String']>;
  insuredNameMiddle?: Maybe<Scalars['String']>;
  insuredNamePrefix?: Maybe<Scalars['String']>;
  insuredNameSuffix?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  patientDob?: Maybe<Scalars['DateTime']>;
  patientNameGiven?: Maybe<Scalars['String']>;
  patientNameLast?: Maybe<Scalars['String']>;
  patientNameMiddle?: Maybe<Scalars['String']>;
  patientNamePrefix?: Maybe<Scalars['String']>;
  patientNameSuffix?: Maybe<Scalars['String']>;
  payerMnemonic?: Maybe<Scalars['String']>;
  payerName?: Maybe<Scalars['String']>;
  planDescription?: Maybe<Scalars['String']>;
  planEffectiveDate?: Maybe<Scalars['DateTime']>;
  planExpirationDate?: Maybe<Scalars['DateTime']>;
  planGroupName?: Maybe<Scalars['String']>;
  planGroupNumber?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPolicyId?: Maybe<Scalars['String']>;
  vendorInsuredNameGiven?: Maybe<Scalars['String']>;
  vendorInsuredNameLast?: Maybe<Scalars['String']>;
  vendorInsuredNameMiddle?: Maybe<Scalars['String']>;
  vendorInsuredNamePrefix?: Maybe<Scalars['String']>;
  vendorInsuredNameSuffix?: Maybe<Scalars['String']>;
  vendorPatientNameGiven?: Maybe<Scalars['String']>;
  vendorPatientNameLast?: Maybe<Scalars['String']>;
  vendorPatientNameMiddle?: Maybe<Scalars['String']>;
  vendorPatientNamePrefix?: Maybe<Scalars['String']>;
  vendorPatientNameSuffix?: Maybe<Scalars['String']>;
  vendorPlanGroupName?: Maybe<Scalars['String']>;
  vendorPlanGroupNumber?: Maybe<Scalars['String']>;
  vendorPlanPolicyId?: Maybe<Scalars['String']>;
};

export type JsonEstimateAttachmentContent = EstimateAttachmentContentType & {
  __typename?: 'JsonEstimateAttachmentContent';
  password?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type JsonEstimateAttachmentInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<PdfEstimateAttachmentContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LanguageModel = {
  __typename?: 'LanguageModel';
  en_US: Scalars['String'];
  es?: Maybe<Scalars['String']>;
};

export type LinkModel = {
  __typename?: 'LinkModel';
  Href?: Maybe<HrefModel>;
  Text?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createEncounterCommunicationMutation: EncounterCommunication;
  createEstimate: Estimate;
  createEstimates?: Maybe<Array<Estimate>>;
  createSession: SessionCommunication;
  deleteEstimates?: Maybe<DeleteEstimatesResponse>;
  triggerEncounterUpdatedEvent: Array<Scalars['String']>;
};


export type MutationCreateEncounterCommunicationMutationArgs = {
  createEncounterCommunicationData: CreateEncounterCommunicationInput;
};


export type MutationCreateEstimateArgs = {
  createEstimateData: CreateEstimateInput;
};


export type MutationCreateEstimatesArgs = {
  createEstimateData: Array<CreateEstimateInput>;
};


export type MutationCreateSessionArgs = {
  createSessionData: CreateSessionInput;
};


export type MutationDeleteEstimatesArgs = {
  deleteEstimatesInput: DeleteEstimatesInput;
};


export type MutationTriggerEncounterUpdatedEventArgs = {
  encounterIds: Array<Scalars['Float']>;
  eventType?: InputMaybe<Scalars['String']>;
  existing?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Float'];
};

export type NameData = {
  __typename?: 'NameData';
  family?: Maybe<Scalars['String']>;
  full?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  middle?: Maybe<Scalars['String']>;
};

export type OrgRsfConfigSeedMap = {
  __typename?: 'OrgRsfConfigSeedMap';
  rsfCommonFieldDictionaryMap?: Maybe<Scalars['String']>;
  rsfFieldKey?: Maybe<Scalars['String']>;
  rsfFieldKeyAliases?: Maybe<Array<Scalars['String']>>;
  source?: Maybe<Scalars['String']>;
};

export enum OrgVisitType {
  Ed = 'ED',
  PrimaryCare = 'PrimaryCare',
  Specialist = 'Specialist'
}

export type Organization = {
  __typename?: 'Organization';
  apcWageIndex?: Maybe<Scalars['String']>;
  apiKeys?: Maybe<Array<Maybe<OrganizationApiKey>>>;
  billingIdentifierType?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  defaultPlaceOfServiceCode?: Maybe<Array<PlaceOfServiceCodeMaster>>;
  displayNameLong: Scalars['String'];
  displayNameShort: Scalars['String'];
  ein?: Maybe<Scalars['String']>;
  em3ConnectionId?: Maybe<Scalars['String']>;
  externalReferenceId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  locations?: Maybe<Array<OrganizationLocation>>;
  lookups?: Maybe<Array<OrganizationLookup>>;
  mac?: Maybe<Scalars['String']>;
  macLocality?: Maybe<Scalars['String']>;
  macLocalityName?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  organizationName: Scalars['String'];
  personaPaySlug?: Maybe<Scalars['String']>;
  retentionDays?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OrganizationApiKey = {
  __typename?: 'OrganizationApiKey';
  apiGatewayId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type OrganizationLocation = {
  __typename?: 'OrganizationLocation';
  apcWageIndex?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countyOrParish?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultLocation?: Maybe<Scalars['Boolean']>;
  defaultPlaceOfServiceCode?: Maybe<PlaceOfServiceCodeMaster>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  em3FacilityId?: Maybe<Scalars['Int']>;
  externalReferenceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mac?: Maybe<Scalars['String']>;
  macLocality?: Maybe<Scalars['String']>;
  macLocalityName?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  orgSiteName?: Maybe<Scalars['String']>;
  orgVisitType?: Maybe<OrgVisitType>;
  organizationId?: Maybe<Scalars['Float']>;
  otherDesignation?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  placeOfServiceCodes?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<Scalars['Int']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zipOrPostalCode?: Maybe<Scalars['String']>;
};

export type OrganizationLookup = {
  __typename?: 'OrganizationLookup';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  dictionary?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationRsfConfig = {
  __typename?: 'OrganizationRsfConfig';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encounterCompleteForms?: Maybe<Array<EncounterCompleteForm>>;
  id: Scalars['ID'];
  label: Scalars['JSON'];
  organizationId?: Maybe<Array<Scalars['Int']>>;
  packets: Array<Scalars['Int']>;
  permission?: Maybe<Permission>;
  permissionId?: Maybe<Array<Scalars['Int']>>;
  seedMap?: Maybe<Array<OrgRsfConfigSeedMap>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ParseError = {
  __typename?: 'ParseError';
  category?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type PatientArgs = {
  organizationExternalId: Scalars['String'];
  patientMrn: Scalars['String'];
  visitNumber?: InputMaybe<Scalars['String']>;
};

export type PatientBase = {
  __typename?: 'PatientBase';
  accountNumber?: Maybe<Scalars['String']>;
  addresses?: Maybe<Array<Address>>;
  addresses_Encrypted?: Maybe<Array<Address>>;
  allergies: Scalars['String'];
  billingIdentifier?: Maybe<Scalars['String']>;
  contactConsent?: Maybe<Scalars['String']>;
  contactPoints?: Maybe<Array<ContactPoint>>;
  contactPreference?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfBirth_Encrypted?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Email>>;
  emails_Encrypted?: Maybe<Array<Email>>;
  emergencyContactBase?: Maybe<EmergencyContactBase>;
  empi?: Maybe<Scalars['String']>;
  ethnicity?: Maybe<Scalars['String']>;
  guarnatorRelationship?: Maybe<Scalars['String']>;
  hasCardOnFile: Scalars['Boolean'];
  isGuarantor?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  lastEngagementDate?: Maybe<Scalars['DateTime']>;
  maritalStatus?: Maybe<Scalars['String']>;
  medicalFamilyHistory: Scalars['String'];
  medicalProblems: Scalars['String'];
  mrn?: Maybe<Scalars['String']>;
  nameFamily?: Maybe<Scalars['String']>;
  nameGiven?: Maybe<Scalars['String']>;
  nameMiddle?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  phoneNumbers_Encrypted?: Maybe<Array<PhoneNumber>>;
  race?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  ssn_Encrypted?: Maybe<Scalars['String']>;
};

export type PatientChecksum = {
  __typename?: 'PatientChecksum';
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  name: Scalars['String'];
  patientMasterId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PatientDocument = {
  __typename?: 'PatientDocument';
  admitDateTime?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  encounterId: Scalars['Float'];
  files?: Maybe<Array<RsfFile>>;
  formSessionId: Scalars['String'];
  images?: Maybe<Array<RsfFormImage>>;
  organizationId: Scalars['Float'];
  patientMrn?: Maybe<Scalars['String']>;
  sendDateTime?: Maybe<Scalars['String']>;
  sessionId: Scalars['String'];
  visitNumber?: Maybe<Scalars['String']>;
};

export type PatientDocumentsHeaderFieldModel = {
  __typename?: 'PatientDocumentsHeaderFieldModel';
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PatientDocumentsHeaderModel = {
  __typename?: 'PatientDocumentsHeaderModel';
  fields?: Maybe<Array<PatientDocumentsHeaderFieldModel>>;
};

export type PatientDocumentsWithVisits = {
  __typename?: 'PatientDocumentsWithVisits';
  documents: Array<PatientDocument>;
  visits: Array<VisitSummary>;
};

export type PatientIdentifier = {
  __typename?: 'PatientIdentifier';
  id: Scalars['Int'];
  patientMasterId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_Encrypted?: Maybe<Scalars['String']>;
};

export type PatientMaster = {
  __typename?: 'PatientMaster';
  accountNumber?: Maybe<Scalars['String']>;
  addresses?: Maybe<Array<Address>>;
  addresses_Encrypted?: Maybe<Array<Address>>;
  allergies: Scalars['String'];
  billingIdentifier?: Maybe<Scalars['String']>;
  checksums?: Maybe<Array<PatientChecksum>>;
  contactConsent?: Maybe<Scalars['String']>;
  contactPoints?: Maybe<Array<ContactPoint>>;
  contactPreference?: Maybe<Scalars['String']>;
  correlationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<PatientMasterData>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfBirth_Encrypted?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Email>>;
  emails_Encrypted?: Maybe<Array<Email>>;
  emergencyContactBase?: Maybe<EmergencyContactBase>;
  empi?: Maybe<Scalars['String']>;
  ethnicity?: Maybe<Scalars['String']>;
  guarnatorRelationship?: Maybe<Scalars['String']>;
  hasCardOnFile: Scalars['Boolean'];
  id: Scalars['Int'];
  identifiers?: Maybe<Array<PatientIdentifier>>;
  isGuarantor?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  lastEngagementDate?: Maybe<Scalars['DateTime']>;
  maritalStatus?: Maybe<Scalars['String']>;
  medicalFamilyHistory: Scalars['String'];
  medicalProblems: Scalars['String'];
  mrn?: Maybe<Scalars['String']>;
  nameFamily?: Maybe<Scalars['String']>;
  nameGiven?: Maybe<Scalars['String']>;
  nameMiddle?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  patientId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  phoneNumbers_Encrypted?: Maybe<Array<PhoneNumber>>;
  race?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  ssn_Encrypted?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitAutoPayEnrolled: Scalars['Boolean'];
};

export type PatientMasterData = {
  __typename?: 'PatientMasterData';
  additionalData: Scalars['JSON'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emergencyContact?: Maybe<ContactData>;
  flags?: Maybe<PatientMasterDataFlags>;
  guarantor?: Maybe<ContactData>;
  guarantorEmployer?: Maybe<EmployerData>;
  id: Scalars['Int'];
  nextOfKin?: Maybe<ContactData>;
  organizationId: Scalars['Int'];
  patient?: Maybe<ContactData>;
  patientEmployer?: Maybe<EmployerData>;
  patientMasterId: Scalars['Int'];
  personToNotify?: Maybe<ContactData>;
  primaryPhysician?: Maybe<ContactData>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PatientMasterDataFlags = {
  __typename?: 'PatientMasterDataFlags';
  advancedDirective?: Maybe<Scalars['String']>;
  vipIndicator?: Maybe<Scalars['String']>;
};

export type PdfEstimateAttachmentContent = EstimateAttachmentContentType & {
  __typename?: 'PdfEstimateAttachmentContent';
  fileSize?: Maybe<Scalars['Int']>;
  internalFileName: Scalars['String'];
  internalFilePath: Scalars['String'];
  md5Checksum: Scalars['String'];
  originalFileName: Scalars['String'];
  originalFilePath: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PdfEstimateAttachmentContentInput = {
  fileSize?: InputMaybe<Scalars['Int']>;
  internalFileName: Scalars['String'];
  internalFilePath: Scalars['String'];
  md5Checksum: Scalars['String'];
  originalFileName: Scalars['String'];
  originalFilePath: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  signedUrl?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PdfEstimateAttachmentInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<PdfEstimateAttachmentContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  permissionKey?: Maybe<Scalars['String']>;
};

export type PhoneData = {
  __typename?: 'PhoneData';
  cell?: Maybe<Scalars['String']>;
  home?: Maybe<Scalars['String']>;
  work?: Maybe<Scalars['String']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  anyText?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  useCode?: Maybe<Scalars['String']>;
};

export type PlaceOfServiceCodeMaster = {
  __typename?: 'PlaceOfServiceCodeMaster';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  placeOfServiceCode?: Maybe<Scalars['String']>;
  serviceComponentTypes?: Maybe<Array<ServiceComponentType>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PlanMasterCopay = {
  __typename?: 'PlanMasterCopay';
  copay: Scalars['Float'];
  id: Scalars['Int'];
  planMasterId?: Maybe<Scalars['Int']>;
  policyPrefixMasterId?: Maybe<Scalars['String']>;
  rsProcedureMaster?: Maybe<RsProcedureMaster>;
  serviceTypeCode?: Maybe<RsServiceTypeCode>;
};

export type Prediction = {
  __typename?: 'Prediction';
  bcl: Scalars['Float'];
  confidentMatch: Scalars['Float'];
  score: Scalars['Float'];
};

export enum ProcedureType {
  Apc = 'APC',
  Cpt = 'CPT',
  Drg = 'DRG',
  Hcpcs = 'HCPCS',
  Icd = 'ICD'
}

export type ProviderLocation = {
  __typename?: 'ProviderLocation';
  city?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countyOrParish?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  otherDesignation?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  zipOrPostalCode?: Maybe<Scalars['String']>;
};

export type ProviderLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countyOrParish?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherDesignation?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  encounter: Encounter;
  encounterCommunication: EncounterCommunication;
  encounterEngagements: EngagementResponse;
  encounterInsurance: EncounterInsurance;
  encounters: EncounterSearchResults;
  encountersWithEngagements: EncounterEngagementsResponse;
  estimate?: Maybe<Estimate>;
  estimateConfig: Array<EstimateConfig>;
  estimateSession: EstimateSession;
  estimates: Array<Estimate>;
  findEncountersAdvanced: EncounterSearchResults;
  images: PatientDocumentsWithVisits;
  renderEstimate: EstimateRenderData;
  renderReport: ReportRenderData;
  statementPdf: Scalars['String'];
  statements: Array<ConsumerStatement>;
};


export type QueryEncounterArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  loadDeletedInsurances?: InputMaybe<Scalars['Boolean']>;
  organizationExternalId: Scalars['String'];
  paths?: InputMaybe<Array<Scalars['String']>>;
  visitNumber?: InputMaybe<Scalars['String']>;
};


export type QueryEncounterCommunicationArgs = {
  organizationExternalId: Scalars['String'];
  type?: InputMaybe<EncounterCommunicationType>;
  visitNumber: Scalars['String'];
};


export type QueryEncounterEngagementsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  endRow?: InputMaybe<Scalars['Float']>;
  filter?: InputMaybe<Scalars['JSON']>;
  organizationId: Scalars['Float'];
  sort?: InputMaybe<Array<EngagementSortArgs>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startRow?: InputMaybe<Scalars['Float']>;
};


export type QueryEncounterInsuranceArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  loadDeletedInsurances?: InputMaybe<Scalars['Boolean']>;
  organizationExternalId: Scalars['String'];
  paths?: InputMaybe<Array<Scalars['String']>>;
  visitNumber?: InputMaybe<Scalars['String']>;
};


export type QueryEncountersArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  index?: Scalars['Int'];
  limit?: Scalars['Int'];
  organizationExternalId: Scalars['String'];
  organizationLocationId?: InputMaybe<Scalars['Int']>;
  paths?: InputMaybe<Array<Scalars['String']>>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryEncountersWithEngagementsArgs = {
  endRow?: InputMaybe<Scalars['Float']>;
  filter?: InputMaybe<Scalars['JSON']>;
  organizationId: Scalars['Float'];
  sort?: InputMaybe<Array<EngagementSortArgs>>;
  startRow?: InputMaybe<Scalars['Float']>;
  withExistingEngagement: Scalars['Boolean'];
};


export type QueryEstimateArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  appName?: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['Int']>;
  estimateNumber?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  includePdf?: InputMaybe<Scalars['Boolean']>;
  language?: Scalars['String'];
  latest?: InputMaybe<Scalars['Boolean']>;
  paths?: InputMaybe<Array<Scalars['String']>>;
  retry?: InputMaybe<EstimateRetryArgs>;
};


export type QueryEstimateConfigArgs = {
  accountId: Scalars['String'];
  appName: Scalars['String'];
  configNames?: InputMaybe<Array<Scalars['String']>>;
  estimateId: Scalars['Int'];
};


export type QueryEstimateSessionArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  appName?: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['Int']>;
  estimateNumber?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  includePdf?: InputMaybe<Scalars['Boolean']>;
  language?: Scalars['String'];
  latest?: InputMaybe<Scalars['Boolean']>;
  paths?: InputMaybe<Array<Scalars['String']>>;
  retry?: InputMaybe<EstimateRetryArgs>;
};


export type QueryEstimatesArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  index?: Scalars['Int'];
  limit?: Scalars['Int'];
  paths?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sessionType?: InputMaybe<Scalars['String']>;
};


export type QueryFindEncountersAdvancedArgs = {
  date?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  estimateAvailable?: InputMaybe<Scalars['Boolean']>;
  index?: Scalars['Int'];
  limit?: Scalars['Int'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mrn?: InputMaybe<Scalars['String']>;
  organizationExternalId: Scalars['String'];
  patientName?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};


export type QueryImagesArgs = {
  patientArgs: PatientArgs;
};


export type QueryRenderEstimateArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  appName?: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['Int']>;
  estimateNumber?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  includePdf?: InputMaybe<Scalars['Boolean']>;
  language?: Scalars['String'];
  latest?: InputMaybe<Scalars['Boolean']>;
  paths?: InputMaybe<Array<Scalars['String']>>;
  retry?: InputMaybe<EstimateRetryArgs>;
};


export type QueryRenderReportArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  data: Scalars['JSON'];
  reportUrl?: InputMaybe<Scalars['String']>;
  themeUrl?: InputMaybe<Scalars['String']>;
};


export type QueryStatementPdfArgs = {
  patientArgs: StatementArgs;
};


export type QueryStatementsArgs = {
  patientArgs: PatientArgs;
};

export type QueueEncounterCommunicationFailureSettings = {
  __typename?: 'QueueEncounterCommunicationFailureSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  jobTypeId?: Maybe<Scalars['Float']>;
};

export type ReportRenderData = {
  __typename?: 'ReportRenderData';
  reportData?: Maybe<Scalars['String']>;
};

export type RsProcedureMaster = {
  __typename?: 'RsProcedureMaster';
  consumerDescriptor: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  longDescription: Scalars['String'];
  longDescriptionUpper: Scalars['String'];
  mediumDescription: Scalars['String'];
  procedureCode: Scalars['String'];
  shortDescription: Scalars['String'];
  type: ProcedureType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version: Scalars['String'];
};

export type RsRevenueCode = {
  __typename?: 'RsRevenueCode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RsServiceTypeCode = {
  __typename?: 'RsServiceTypeCode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RsfApiKey = {
  __typename?: 'RsfApiKey';
  apiGatewayId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type RsfEvent = {
  __typename?: 'RsfEvent';
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventAction: RsfEventAction;
  eventType: RsfEventType;
  id: Scalars['ID'];
  organization?: Maybe<RsfOrganization>;
  payload: Scalars['JSONObject'];
  rules?: Maybe<Scalars['JSONObject']>;
  sender: Scalars['String'];
  sessionId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfEventAction = {
  __typename?: 'RsfEventAction';
  id: Scalars['ID'];
  key: Scalars['String'];
  title: Scalars['String'];
};

export type RsfEventType = {
  __typename?: 'RsfEventType';
  id: Scalars['ID'];
  key: Scalars['String'];
  title: Scalars['String'];
};

export type RsfFile = {
  __typename?: 'RsfFile';
  b64file?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  sessionDisposition?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  viewOnlyId?: Maybe<Scalars['String']>;
};

export type RsfForm = {
  __typename?: 'RsfForm';
  createdAt?: Maybe<Scalars['DateTime']>;
  filename: LanguageModel;
  formId: Scalars['String'];
  formName: LanguageModel;
  formType: Scalars['String'];
  id: Scalars['ID'];
  packet?: Maybe<RsfPacket>;
  priority: Scalars['Int'];
  questions?: Maybe<Array<Maybe<RsfQuestion>>>;
  templateFields?: Maybe<Array<Maybe<RsfFormTemplateField>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validationLevel: Scalars['String'];
};

export type RsfFormImage = {
  __typename?: 'RsfFormImage';
  createdAt?: Maybe<Scalars['String']>;
  formId: Scalars['Float'];
  image?: Maybe<RsfImage>;
};

export type RsfFormTemplateField = {
  __typename?: 'RsfFormTemplateField';
  fieldId: Scalars['String'];
  isBarcode: Scalars['Boolean'];
  pdfControlLabel: Scalars['String'];
  pdfControlName: Scalars['String'];
};

export type RsfImage = {
  __typename?: 'RsfImage';
  b64File?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  s3url?: Maybe<Scalars['String']>;
  s3urlSigned?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RsfOrganization = {
  __typename?: 'RsfOrganization';
  apiKeys?: Maybe<Array<Maybe<RsfApiKey>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalReferenceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfPacket = {
  __typename?: 'RsfPacket';
  createdAt?: Maybe<Scalars['DateTime']>;
  criteria?: Maybe<Array<RsfPacketCriterion>>;
  forms?: Maybe<Array<Maybe<RsfForm>>>;
  id: Scalars['ID'];
  packetId: Scalars['String'];
  packetName: LanguageModel;
  priority: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfPacketCriterion = {
  __typename?: 'RsfPacketCriterion';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  packet?: Maybe<Array<RsfPacket>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfQuestion = {
  __typename?: 'RsfQuestion';
  aliasFields?: Maybe<Array<Scalars['String']>>;
  attributes?: Maybe<Array<Maybe<RsfQuestionAttribute>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ctrlValidation?: Maybe<RsfQuestionControlValidation>;
  defaultAnswer?: Maybe<Scalars['String']>;
  displayIf?: Maybe<Scalars['JSON']>;
  form?: Maybe<RsfForm>;
  group?: Maybe<RsfQuestionGroup>;
  id: Scalars['ID'];
  mask?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<RsfQuestionOption>>>;
  pdfControlName?: Maybe<Scalars['String']>;
  pdfControlType?: Maybe<Scalars['String']>;
  postText?: Maybe<Array<Maybe<LanguageModel>>>;
  preText?: Maybe<Array<Maybe<LanguageModel>>>;
  priority?: Maybe<Scalars['Int']>;
  questionControlType: Scalars['String'];
  questionId: Scalars['String'];
  questionText: LanguageModel;
  readonly?: Maybe<Scalars['Boolean']>;
  relatedQuestionIds?: Maybe<Array<Maybe<RsfRelatedQuestion>>>;
  required?: Maybe<Scalars['Boolean']>;
  requiredIf?: Maybe<Scalars['JSON']>;
  staffonly?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfQuestionAttribute = {
  __typename?: 'RsfQuestionAttribute';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RsfQuestionControlValidation = {
  __typename?: 'RsfQuestionControlValidation';
  criteria: Scalars['String'];
  validators: Scalars['JSON'];
};

export type RsfQuestionGroup = {
  __typename?: 'RsfQuestionGroup';
  createdAt?: Maybe<Scalars['DateTime']>;
  groupDescription: Scalars['String'];
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  id: Scalars['ID'];
  questions?: Maybe<Array<Maybe<RsfQuestion>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfQuestionOption = {
  __typename?: 'RsfQuestionOption';
  additionalField?: Maybe<RsfQuestionOption>;
  key: Scalars['String'];
  outcome: Scalars['String'];
  showAdditionalField: Scalars['Boolean'];
  value: Scalars['String'];
};

export type RsfRelatedQuestion = {
  __typename?: 'RsfRelatedQuestion';
  h?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  pageNumber?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  scale?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
  w?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type RsfSession = {
  __typename?: 'RsfSession';
  closedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disposition?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<RsfEvent>>>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  friendlySessionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  organization?: Maybe<RsfOrganization>;
  organizationId?: Maybe<Scalars['Int']>;
  personIdentifier?: Maybe<Scalars['String']>;
  seedData?: Maybe<Array<Maybe<RsfSessionSeedData>>>;
  selectedLanguage?: Maybe<Scalars['String']>;
  sessionGuid?: Maybe<Scalars['String']>;
  sessionPackets?: Maybe<Array<Maybe<RsfSessionPacket>>>;
  signers?: Maybe<Array<Maybe<RsfSessionSigner>>>;
  startedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfSessionForm = {
  __typename?: 'RsfSessionForm';
  closedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Array<RsfSessionFormData>>;
  disposition: Scalars['String'];
  form?: Maybe<RsfForm>;
  formId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  sessionId: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfSessionFormData = {
  __typename?: 'RsfSessionFormData';
  createdAt?: Maybe<Scalars['DateTime']>;
  eSigned?: Maybe<Scalars['Boolean']>;
  fileLocation?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  formData?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  isValid?: Maybe<Scalars['Boolean']>;
  session?: Maybe<RsfSession>;
  signedUrl?: Maybe<Scalars['String']>;
};

export type RsfSessionPacket = {
  __typename?: 'RsfSessionPacket';
  closedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disposition?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  packet?: Maybe<RsfPacket>;
  packetId?: Maybe<Scalars['Int']>;
  sessionForms?: Maybe<Array<Maybe<RsfSessionForm>>>;
  sessionId: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RsfSessionSeedData = {
  __typename?: 'RsfSessionSeedData';
  commonFieldDictionaryMap?: Maybe<Scalars['String']>;
  fieldKey: Scalars['String'];
  fieldKeyAliases?: Maybe<Array<Scalars['String']>>;
  fieldValue: Scalars['String'];
};

export type RsfSessionSigner = {
  __typename?: 'RsfSessionSigner';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  sessionId: Scalars['Int'];
  signerId: Scalars['String'];
  signerType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RteVendorRequest = {
  __typename?: 'RteVendorRequest';
  data?: Maybe<Scalars['JSON']>;
  data_Encrypted?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['ID']>;
};

export type RteVendorResponse = {
  __typename?: 'RteVendorResponse';
  data?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['ID']>;
  rejectionReason?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['Float']>;
  vendorRequest?: Maybe<RteVendorRequest>;
};

export type SaveSessionAuthCommand = {
  loginFieldKey: Scalars['String'];
  loginFieldLabel: Scalars['String'];
};

export type SaveSessionDataCommand = {
  commonFieldDictionaryMap?: InputMaybe<Scalars['String']>;
  fieldKey: Scalars['String'];
  fieldKeyAliases?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldValue: Scalars['String'];
};

export type SaveSessionSignersCommand = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  signerType: Scalars['String'];
};

export type ServiceComponentType = {
  __typename?: 'ServiceComponentType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  placeOfServiceCode?: Maybe<Scalars['String']>;
  placeOfServiceCodeMasterId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SessionCommunication = {
  __typename?: 'SessionCommunication';
  encounterCommunication: EncounterCommunication;
  session: RsfSession;
};

export type StatementAccount = {
  __typename?: 'StatementAccount';
  AccountNumber?: Maybe<Scalars['String']>;
  AccountTotalAdjustments?: Maybe<Scalars['String']>;
  AccountTotalBalance?: Maybe<Scalars['String']>;
  AccountTotalCharges?: Maybe<Scalars['String']>;
  AccountTotalPayments?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  ConsumerNumber?: Maybe<Scalars['String']>;
  CreateDate?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  DunningLevel?: Maybe<Scalars['String']>;
  DunningMessage?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['String']>;
  PaymentPlanFlag?: Maybe<Scalars['String']>;
  StatementId?: Maybe<Scalars['String']>;
  SuppressionFlag?: Maybe<Scalars['String']>;
  SuppressionReason?: Maybe<Scalars['String']>;
  UpdateDate?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
};

export type StatementArgs = {
  patientMrn: Scalars['String'];
  pdfId: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  estimateUpdated?: Maybe<EstimateChanged>;
};


export type SubscriptionEstimateUpdatedArgs = {
  externalReferenceId: Scalars['String'];
  language?: Scalars['String'];
};

export type TemplateParams = {
  __typename?: 'TemplateParams';
  scenario?: Maybe<Scalars['String']>;
  templateAlias?: Maybe<Scalars['String']>;
  templateGuid?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
};

export type TemplateParamsInput = {
  scenario?: InputMaybe<Scalars['String']>;
  templateAlias?: InputMaybe<Scalars['String']>;
  templateGuid?: InputMaybe<Scalars['String']>;
  templateName?: InputMaybe<Scalars['String']>;
};

export type UnableToDetermineContactPointInfo = {
  __typename?: 'UnableToDetermineContactPointInfo';
  contactName?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['String']>;
  contactValue?: Maybe<Scalars['String']>;
};

export type VerificationResultMessage = {
  __typename?: 'VerificationResultMessage';
  error: Scalars['Boolean'];
  message: Scalars['String'];
  warning: Scalars['Boolean'];
};

export type VisitSummary = {
  __typename?: 'VisitSummary';
  admitDateTime: Scalars['String'];
  visitNumber: Scalars['String'];
};

export type ActionFragment = { __typename?: 'EncounterDetailsGroupModel', title?: string | null, subTitle?: string | null, status?: string | null, action?: string | null, actionLabel?: string | null, payload?: any | null, details?: { __typename?: 'EncounterDetailsFieldModel', title?: string | null, payload?: any | null } | null, fields: Array<{ __typename?: 'EncounterDetailsFieldModel', title?: string | null, titleDescription?: string | null, status?: string | null, value?: string | null, action?: string | null, actionLabel?: string | null, payload?: any | null, class?: string | null, copyToClipboard?: boolean | null, category?: { __typename?: 'EncounterDetailsFieldCategory', categoryTitle?: string | null, categoryOrder?: string | null } | null }> };

export type AddressFragment = { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null };

export type DownloadPatientStatementQueryVariables = Exact<{
  patientArgs: StatementArgs;
}>;


export type DownloadPatientStatementQuery = { __typename?: 'Query', statementPdf: string };

export type EstimateRenderFieldsFragment = { __typename?: 'EstimateRenderData', id?: number | null, estimateNumber?: string | null, estimateScore?: string | null, title?: string | null, type?: string | null, patientName?: string | null, pdfData?: string | null, procedures?: Array<string> | null, estimateSessionId?: string | null, createdAt?: any | null, alertMessage?: Array<string> | null, estimateConfig?: any | null, providerNpi?: string | null, estimateStatus?: { __typename?: 'EstimateStatus', result?: string | null, reason?: string | null, reasonFriendly?: string | null } | null, procedureDetails?: Array<{ __typename?: 'EstimateProcedure', code?: string | null, description?: string | null }> | null, primaryServiceLocation?: { __typename?: 'ProviderLocation', name?: string | null, mailingAddress?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, contactPhone?: string | null } | null, summary?: { __typename?: 'EstimateSummary', amount?: number | null, showBenefitDisclaimer?: boolean | null, totals?: Array<{ __typename?: 'EstimateGroupModel', title?: string | null, diagnosisCodes?: Array<string> | null, procedureCode?: string | null, headerVisible?: boolean | null, totalVisible?: boolean | null, totals?: Array<{ __typename?: 'EstimateGroupLineModel', label?: string | null, value?: string | null, class?: string | null }> | null }> | null, responsibility?: { __typename?: 'EstimateGroupLineModel', label?: string | null, value?: string | null, class?: string | null } | null } | null, estimateSession?: { __typename?: 'EstimateSession', externalReferenceId?: string | null, tags?: any | null, status?: string | null, id?: string | null } | null, attachments?: Array<{ __typename?: 'EstimateAttachment', id: string, type?: string | null, content?: { __typename?: 'EmbeddedEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | { __typename?: 'JsonEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | { __typename?: 'PdfEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | null } | null> | null, headerActions?: Array<{ __typename?: 'EstimateHeaderAction', label?: string | null, action?: string | null }> | null };

export type FindEncountersAdvancedQueryVariables = Exact<{
  organizationExternalId: Scalars['String'];
  index?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  patientName?: InputMaybe<Scalars['String']>;
  mrn?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
  estimateAvailable?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type FindEncountersAdvancedQuery = { __typename?: 'Query', findEncountersAdvanced: { __typename?: 'EncounterSearchResults', total: number, data: Array<{ __typename?: 'Encounter', id: string, visitNumber: string, correlationId?: string | null, encounterState: number, fullName?: string | null, consumerNumber?: string | null, admitDateTime?: any | null, scheduledOn?: any | null, formCompleted?: boolean | null, dateOfBirth?: any | null, hasEstimate?: boolean | null, location?: string | null, primaryInsuranceBenefitStatus?: BenefitStatus | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, organization?: { __typename?: 'Organization', id: string, timezone?: string | null } | null, organizationLocation?: { __typename?: 'OrganizationLocation', id: string, timezone?: string | null } | null, procedures?: Array<{ __typename?: 'EncounterProcedure', procedureCode?: string | null }> | null, patientBase?: { __typename?: 'PatientMaster', hasCardOnFile: boolean, accountNumber?: string | null, addresses?: Array<{ __typename?: 'Address', verification?: { __typename?: 'AddressVerification', status?: string | null } | null }> | null } | null, insurance?: { __typename?: 'EncounterInsurance', planId?: string | null, payerId?: string | null, payerName?: string | null, planNetwork?: string | null, status?: string | null } | null, orgRsfConfigs?: Array<{ __typename?: 'OrganizationRsfConfig', id: string, label: any, encounterCompleteForms?: Array<{ __typename?: 'EncounterCompleteForm', formSessionId: string }> | null }> | null }> } };

export type FindEncounterQueryVariables = Exact<{
  organizationExternalId: Scalars['String'];
  encounterId?: InputMaybe<Scalars['Int']>;
  visitNumber?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  loadDeletedInsurances?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindEncounterQuery = { __typename?: 'Query', encounter: { __typename?: 'Encounter', id: string, visitNumber: string, correlationId?: string | null, externalId: string, encounterState: number, fullName?: string | null, group?: string | null, dateOfBirth?: any | null, consumerNumber?: string | null, scheduledOn?: any | null, doNotUseInsurances: boolean, hasEstimate?: boolean | null, syncAddresses: boolean, acknowledgedEstimateDisclaimerAt?: any | null, acknowledgedEstimateDisclaimer?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, isRteEligible: boolean, paymentIsEligible?: boolean | null, language: any, diagnoses?: Array<{ __typename?: 'Diagnosis', id?: string | null, code?: string | null, description?: string | null } | null> | null, contactPoints: Array<{ __typename?: 'ContactPoint', system?: string | null, value?: string | null, use?: string | null, rank: number, anyText?: string | null, consent?: string | null }>, communications?: Array<{ __typename?: 'EncounterCommunication', alias: string, formSessionId?: string | null, type?: EncounterCommunicationType | null, createdAt?: any | null }> | null, header: { __typename?: 'EncounterHeaderModel', fields: Array<{ __typename?: 'EncounterHeaderFieldModel', title?: string | null, value?: string | null }>, actions?: Array<{ __typename?: 'EncounterHeaderActionModel', title?: string | null, action?: string | null, payload?: any | null }> | null }, patientDocuments?: { __typename?: 'PatientDocumentsHeaderModel', fields?: Array<{ __typename?: 'PatientDocumentsHeaderFieldModel', title?: string | null, value?: string | null }> | null } | null, procedures?: Array<{ __typename?: 'EncounterProcedure', id: string, procedureCode?: string | null, procedureDisplayName?: string | null }> | null, actions: Array<{ __typename?: 'EncounterDetailsGroupModel', title?: string | null, subTitle?: string | null, status?: string | null, action?: string | null, actionLabel?: string | null, payload?: any | null, details?: { __typename?: 'EncounterDetailsFieldModel', title?: string | null, payload?: any | null } | null, fields: Array<{ __typename?: 'EncounterDetailsFieldModel', title?: string | null, titleDescription?: string | null, status?: string | null, value?: string | null, action?: string | null, actionLabel?: string | null, payload?: any | null, class?: string | null, copyToClipboard?: boolean | null, category?: { __typename?: 'EncounterDetailsFieldCategory', categoryTitle?: string | null, categoryOrder?: string | null } | null }> }>, insuranceActions: Array<{ __typename?: 'EncounterDetailsGroupModel', title?: string | null, subTitle?: string | null, status?: string | null, action?: string | null, actionLabel?: string | null, payload?: any | null, details?: { __typename?: 'EncounterDetailsFieldModel', title?: string | null, payload?: any | null } | null, fields: Array<{ __typename?: 'EncounterDetailsFieldModel', title?: string | null, titleDescription?: string | null, status?: string | null, value?: string | null, action?: string | null, actionLabel?: string | null, payload?: any | null, class?: string | null, copyToClipboard?: boolean | null, category?: { __typename?: 'EncounterDetailsFieldCategory', categoryTitle?: string | null, categoryOrder?: string | null } | null }> }>, estimate?: { __typename?: 'Estimate', id: string, estimateStatus?: { __typename?: 'EstimateStatus', result?: string | null, reasonFriendly?: string | null, reason?: string | null } | null } | null, organization?: { __typename?: 'Organization', id: string, timezone?: string | null, externalReferenceId?: string | null } | null, organizationLocation?: { __typename?: 'OrganizationLocation', id: string, timezone?: string | null } | null, orgRsfConfigs?: Array<{ __typename?: 'OrganizationRsfConfig', id: string, label: any, encounterCompleteForms?: Array<{ __typename?: 'EncounterCompleteForm', formSessionId: string }> | null }> | null, patientBase?: { __typename?: 'PatientMaster', nameGiven?: string | null, nameMiddle?: string | null, nameFamily?: string | null, sex?: string | null, dateOfBirth?: any | null, accountNumber?: string | null, mrn?: string | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', useCode?: string | null, phoneNumber?: string | null }> | null, emails?: Array<{ __typename?: 'Email', emailAddress?: string | null }> | null, addresses?: Array<{ __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null, verification?: { __typename?: 'AddressVerification', status?: string | null, lastVerifiedOn?: string | null, addressUpdated?: boolean | null, addressStandardized?: boolean | null, validated?: boolean | null, verifiedAddress?: { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null } | null, originalAddress?: { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null } | null, messages?: Array<{ __typename?: 'AddressVerificationMessage', message: string, warning: boolean, error: boolean, footnote?: string | null }> | null } | null }> | null, emergencyContactBase?: { __typename?: 'EmergencyContactBase', nameFamily?: string | null, nameGiven?: string | null, nameMiddle?: string | null, namePrefix?: string | null, nameSuffix?: string | null, sex?: string | null, dateOfBirth?: any | null, patientRelationship?: string | null, addresses?: Array<{ __typename?: 'Address', mailingAddress?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, otherDesignation?: string | null }> | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', phoneNumber?: string | null }> | null, emails?: Array<{ __typename?: 'Email', emailAddress?: string | null }> | null, contactPoints?: Array<{ __typename?: 'ContactPoint', system?: string | null, value?: string | null, use?: string | null, rank: number, anyText?: string | null, consent?: string | null }> | null } | null } | null, guarantorBase?: { __typename?: 'GuarantorBase', nameGiven?: string | null, nameFamily?: string | null, nameMiddle?: string | null, namePrefix?: string | null, nameSuffix?: string | null, sex?: string | null, dateOfBirth?: any | null, relationship?: string | null, ssn?: string | null, addresses?: Array<{ __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null, verification?: { __typename?: 'AddressVerification', status?: string | null, lastVerifiedOn?: string | null, addressUpdated?: boolean | null, addressStandardized?: boolean | null, validated?: boolean | null, verifiedAddress?: { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null } | null, originalAddress?: { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null } | null, messages?: Array<{ __typename?: 'AddressVerificationMessage', message: string, warning: boolean, error: boolean, footnote?: string | null }> | null } | null }> | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', phoneNumber?: string | null, useCode?: string | null }> | null, emails?: Array<{ __typename?: 'Email', emailAddress?: string | null }> | null, contactPoints?: Array<{ __typename?: 'ContactPoint', system?: string | null, value?: string | null, use?: string | null, rank: number, anyText?: string | null, consent?: string | null }> | null } | null, insurances?: Array<{ __typename?: 'EncounterInsurance', id: string, priority?: number | null, planId?: string | null, payerId?: string | null, planType?: string | null, planMasterId?: number | null, policyNumber?: string | null, payerName?: string | null, groupNumber?: string | null, groupName?: string | null, insuredNameFamily?: string | null, insuredNameGiven?: string | null, insuredNameMiddle?: string | null, insuredNameSuffix?: string | null, insuredNamePrefix?: string | null, insuredDob?: any | null, insuredRelationship?: string | null, insuredSex?: string | null, insuredSsn?: string | null, hicNumber?: string | null, medicaidCaseNumber?: string | null, studentIndicator?: boolean | null, memberNumber?: string | null, isMemberSubscriber?: boolean | null, dateOfServiceBegin?: any | null, dateOfServiceEnd?: any | null, planExpirationDate?: any | null, planEffectiveDate?: any | null, status?: string | null, planName?: string | null, planNetwork?: string | null, isRteEligible: boolean, imageFront?: string | null, imageBack?: string | null, deletedAt?: any | null }> | null, payments?: Array<{ __typename?: 'EncounterPayment', id: string, consumerNumber: string, accountNumber: string, transactionId: number, transactionDate: any, transactionType?: string | null, transactionStatus: string, paymentMethod?: string | null, paymentSource?: string | null, entryMode?: string | null, confirmationNumber: string, amount: number }> | null, arrivedNotes?: Array<{ __typename?: 'EncounterArrivedNotes', noteId?: number | null, createdDate?: string | null, modifiedDate?: string | null, noteType?: string | null, emailAddress?: string | null, userId?: string | null, checkinId?: string | null, patientId?: string | null, notes?: string | null }> | null, alerts?: Array<{ __typename?: 'EncounterAlert', id?: number | null, type?: string | null, label?: string | null, subLabel?: string | null, severity?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null, auxiliaryData?: Array<{ __typename?: 'EncounterData', key: string, value: any }> | null } };

export type FindEncountersQueryVariables = Exact<{
  organizationExternalId: Scalars['String'];
  index?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  encountersId?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  organizationLocationId?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
}>;


export type FindEncountersQuery = { __typename?: 'Query', encounters: { __typename?: 'EncounterSearchResults', total: number, data: Array<{ __typename?: 'Encounter', id: string, visitNumber: string, correlationId?: string | null, encounterState: number, fullName?: string | null, consumerNumber?: string | null, admitDateTime?: any | null, scheduledOn?: any | null, formCompleted?: boolean | null, dateOfBirth?: any | null, hasEstimate?: boolean | null, location?: string | null, primaryInsuranceBenefitStatus?: BenefitStatus | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, organization?: { __typename?: 'Organization', id: string, timezone?: string | null } | null, organizationLocation?: { __typename?: 'OrganizationLocation', id: string, timezone?: string | null } | null, procedures?: Array<{ __typename?: 'EncounterProcedure', procedureCode?: string | null }> | null, patientBase?: { __typename?: 'PatientMaster', hasCardOnFile: boolean, accountNumber?: string | null, mrn?: string | null, addresses?: Array<{ __typename?: 'Address', verification?: { __typename?: 'AddressVerification', status?: string | null } | null }> | null } | null, insurance?: { __typename?: 'EncounterInsurance', planId?: string | null, payerId?: string | null, payerName?: string | null, planNetwork?: string | null, status?: string | null } | null, orgRsfConfigs?: Array<{ __typename?: 'OrganizationRsfConfig', id: string, label: any, encounterCompleteForms?: Array<{ __typename?: 'EncounterCompleteForm', formSessionId: string }> | null }> | null }> } };

export type GetEncounterEngagementsQueryVariables = Exact<{
  organizationId: Scalars['Float'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  sort?: InputMaybe<Array<EngagementSortArgs> | EngagementSortArgs>;
  filter?: InputMaybe<Scalars['JSON']>;
  startRow?: InputMaybe<Scalars['Float']>;
  endRow?: InputMaybe<Scalars['Float']>;
}>;


export type GetEncounterEngagementsQuery = { __typename?: 'Query', encounterEngagements: { __typename?: 'EngagementResponse', lastRow?: number | null, rows?: Array<{ __typename?: 'EncounterEngagement', id: string, engagementIdentifier: string, createdAt?: any | null, updatedAt?: any | null, completedAt?: any | null, currentStatus?: string | null, events: Array<{ __typename?: 'EncounterEngagementEvent', id: string, eventType: EncounterEngagementEventType, sourceEvent: any, createdAt?: any | null, updatedAt?: any | null }>, encounter: { __typename?: 'Encounter', id: string, visitNumber: string, encounterBase?: { __typename?: 'PatientBase', nameFamily?: string | null, nameGiven?: string | null } | null } }> | null } };

export type GetEncounterWithEngagementsQueryVariables = Exact<{
  organizationId: Scalars['Float'];
  sort?: InputMaybe<Array<EngagementSortArgs> | EngagementSortArgs>;
  filter?: InputMaybe<Scalars['JSON']>;
  startRow?: InputMaybe<Scalars['Float']>;
  endRow?: InputMaybe<Scalars['Float']>;
  withExistingEngagement: Scalars['Boolean'];
}>;


export type GetEncounterWithEngagementsQuery = { __typename?: 'Query', encountersWithEngagements: { __typename?: 'EncounterEngagementsResponse', lastRow?: number | null, rows?: Array<{ __typename?: 'Encounter', id: string, visitNumber: string, createdAt?: any | null, auxiliaryData?: Array<{ __typename?: 'EncounterData', key: string, value: any }> | null, encounterBase?: { __typename?: 'PatientBase', mrn?: string | null, nameFamily?: string | null, nameGiven?: string | null, contactPoints?: Array<{ __typename?: 'ContactPoint', system?: string | null, value?: string | null }> | null } | null, guarantorBase?: { __typename?: 'GuarantorBase', contactPoints?: Array<{ __typename?: 'ContactPoint', system?: string | null, value?: string | null }> | null } | null, engagements?: Array<{ __typename?: 'EncounterEngagement', id: string, engagementIdentifier: string, createdAt?: any | null, updatedAt?: any | null, completedAt?: any | null, currentStatus?: string | null, events: Array<{ __typename?: 'EncounterEngagementEvent', id: string, eventType: EncounterEngagementEventType, sourceEvent: any, createdAt?: any | null, updatedAt?: any | null }> }> | null }> | null } };

export type GetEstimateSummaryQueryVariables = Exact<{
  estimateId?: InputMaybe<Scalars['Int']>;
  estimateNumber?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['String']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  paths?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  retry?: InputMaybe<EstimateRetryArgs>;
  category?: InputMaybe<Scalars['String']>;
}>;


export type GetEstimateSummaryQuery = { __typename?: 'Query', estimate?: { __typename?: 'Estimate', createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, id: string, estimateNumber?: string | null, planId?: string | null, payerId?: string | null, payerName?: string | null, planType?: string | null, policyNumber?: string | null, groupNumber?: string | null, groupName?: string | null, totalPatientResponsibility?: number | null, totalAllowedAmount?: number | null, appliedToDeductible?: number | null, dedRemainingIndAmount?: number | null, dedRemainingFamAmount?: number | null, oopIndUsedAmount?: number | null, oopIndMaxAmount?: number | null, oopFamUsedAmount?: number | null, oopFamMaxAmount?: number | null, oopIndMaxMet?: boolean | null, oopFamMaxMet?: boolean | null, deductibleMet?: boolean | null, outOfNetwork?: boolean | null, isSelfPay?: boolean | null, hasBenefits?: boolean | null, dedFamRemainingAfterEstimate?: number | null, dedIndRemainingAfterEstimate?: number | null, dedFamMaxAmount?: number | null, dedIndMaxAmount?: number | null, accountId?: number | null, estimateLogId?: number | null, estimateStatusId?: number | null, estimateSessionId?: number | null, estimateStatementId?: number | null, payerMasterId?: number | null, planMasterId?: number | null, source: string, type: string, patientName?: string | null, patientMrn?: string | null, patientDob?: any | null, primaryService?: string | null, primaryServiceScheduled?: any | null, estimateStatus?: { __typename?: 'EstimateStatus', createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, id?: string | null, result?: string | null, reason?: string | null, reasonFriendly?: string | null, hasCdm?: boolean | null, hasContract?: boolean | null, hasRte?: boolean | null, copayOnly?: boolean | null } | null, diagnoses?: Array<{ __typename?: 'Diagnosis', id?: string | null, code?: string | null, description?: string | null }> | null, estimateScore?: Array<{ __typename?: 'EstimateScore', score?: number | null, scoringAlgorithmVersion?: string | null }> | null, estimateSession?: { __typename?: 'EstimateSession', externalReferenceId?: string | null, id?: string | null } | null } | null };

export type GetEstimatesSummaryQueryVariables = Exact<{
  index?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['String']>;
  sessionType?: InputMaybe<Scalars['String']>;
}>;


export type GetEstimatesSummaryQuery = { __typename?: 'Query', estimates: Array<{ __typename?: 'Estimate', createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, id: string, estimateNumber?: string | null, planId?: string | null, payerId?: string | null, payerName?: string | null, planType?: string | null, policyNumber?: string | null, groupNumber?: string | null, groupName?: string | null, totalPatientResponsibility?: number | null, totalAllowedAmount?: number | null, appliedToDeductible?: number | null, dedRemainingIndAmount?: number | null, dedRemainingFamAmount?: number | null, oopIndUsedAmount?: number | null, oopIndMaxAmount?: number | null, oopFamUsedAmount?: number | null, oopFamMaxAmount?: number | null, oopIndMaxMet?: boolean | null, oopFamMaxMet?: boolean | null, deductibleMet?: boolean | null, outOfNetwork?: boolean | null, isSelfPay?: boolean | null, hasBenefits?: boolean | null, dedFamRemainingAfterEstimate?: number | null, dedIndRemainingAfterEstimate?: number | null, dedFamMaxAmount?: number | null, dedIndMaxAmount?: number | null, accountId?: number | null, estimateLogId?: number | null, estimateStatusId?: number | null, estimateSessionId?: number | null, estimateStatementId?: number | null, payerMasterId?: number | null, planMasterId?: number | null, source: string, type: string, patientName?: string | null, patientMrn?: string | null, patientDob?: any | null, primaryService?: string | null, primaryServiceScheduled?: any | null, estimateSession?: { __typename?: 'EstimateSession', externalReferenceId?: string | null, id?: string | null } | null }> };

export type GetPatientImagesQueryVariables = Exact<{
  patientArgs: PatientArgs;
}>;


export type GetPatientImagesQuery = { __typename?: 'Query', images: { __typename?: 'PatientDocumentsWithVisits', documents: Array<{ __typename?: 'PatientDocument', sessionId: string, organizationId: number, formSessionId: string, encounterId: number, patientMrn?: string | null, visitNumber?: string | null, admitDateTime?: string | null, sendDateTime?: string | null, alias: string, images?: Array<{ __typename?: 'RsfFormImage', formId: number, createdAt?: string | null, image?: { __typename?: 'RsfImage', name?: string | null, size?: number | null, type?: string | null, b64File?: string | null, s3url?: string | null, s3urlSigned?: string | null } | null }> | null, files?: Array<{ __typename?: 'RsfFile', sessionId?: string | null, formId?: number | null, viewOnlyId?: string | null, organizationId?: number | null, sessionDisposition?: string | null, b64file?: string | null, fileUrl?: string | null, signedUrl?: string | null, fileName?: string | null, createdAt?: any | null }> | null }>, visits: Array<{ __typename?: 'VisitSummary', visitNumber: string, admitDateTime: string }> } };

export type GetPatientStatementsQueryVariables = Exact<{
  patientArgs: PatientArgs;
}>;


export type GetPatientStatementsQuery = { __typename?: 'Query', statements: Array<{ __typename?: 'ConsumerStatement', Id?: string | null, ClientId?: string | null, ConsumerNumber?: string | null, StatementId?: string | null, StatementNumber?: string | null, FirstName?: string | null, MiddleName?: string | null, LastName?: string | null, FullName?: string | null, Address1?: string | null, Address2?: string | null, Address3?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Country?: string | null, PdfId?: string | null, StatementDate?: string | null, RunStampDate?: string | null, LastStatementDate?: string | null, FirstStatementDate?: string | null, DunningType?: string | null, DunningLevel?: string | null, TotalDebits?: string | null, TotalCredits?: string | null, AmountDue?: string | null, TotalBalance?: string | null, PaymentDueDate?: string | null, PaymentPlanAmountDue?: string | null, DiscountPercent?: string | null, PromptPayDiscountFlag?: string | null, PromptPayDiscountAmount?: string | null, PromptPayFlag?: string | null, PromptPayEndDate?: string | null, StatementMessage?: string | null, FileName?: string | null, LetterCode?: string | null, Facility?: string | null, SuppressionFlag?: string | null, SuppressionReason?: string | null, Score?: string | null, BCL?: string | null, FPL?: string | null, Charity?: string | null, CreateDate?: string | null, UpdateDate?: string | null, CreatedBy?: string | null, UpdatedBy?: string | null, StatementAccount?: Array<{ __typename?: 'StatementAccount', Id?: string | null, ClientId?: string | null, ConsumerNumber?: string | null, AccountNumber?: string | null, StatementId?: string | null, AccountTotalBalance?: string | null, AccountTotalCharges?: string | null, AccountTotalPayments?: string | null, AccountTotalAdjustments?: string | null, DunningLevel?: string | null, DunningMessage?: string | null, PaymentPlanFlag?: string | null, SuppressionFlag?: string | null, SuppressionReason?: string | null, CreateDate?: string | null, UpdateDate?: string | null, CreatedBy?: string | null, UpdatedBy?: string | null }> | null }> };

export type RenderEstimateQueryVariables = Exact<{
  appName?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['Int']>;
  estimateNumber?: InputMaybe<Scalars['String']>;
  externalReferenceId?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['String']>;
  paths?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includePdf?: InputMaybe<Scalars['Boolean']>;
  latest?: InputMaybe<Scalars['Boolean']>;
}>;


export type RenderEstimateQuery = { __typename?: 'Query', renderEstimate: { __typename?: 'EstimateRenderData', id?: number | null, estimateNumber?: string | null, estimateScore?: string | null, title?: string | null, type?: string | null, patientName?: string | null, pdfData?: string | null, procedures?: Array<string> | null, estimateSessionId?: string | null, createdAt?: any | null, alertMessage?: Array<string> | null, estimateConfig?: any | null, providerNpi?: string | null, estimateStatus?: { __typename?: 'EstimateStatus', result?: string | null, reason?: string | null, reasonFriendly?: string | null } | null, procedureDetails?: Array<{ __typename?: 'EstimateProcedure', code?: string | null, description?: string | null }> | null, primaryServiceLocation?: { __typename?: 'ProviderLocation', name?: string | null, mailingAddress?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, contactPhone?: string | null } | null, summary?: { __typename?: 'EstimateSummary', amount?: number | null, showBenefitDisclaimer?: boolean | null, totals?: Array<{ __typename?: 'EstimateGroupModel', title?: string | null, diagnosisCodes?: Array<string> | null, procedureCode?: string | null, headerVisible?: boolean | null, totalVisible?: boolean | null, totals?: Array<{ __typename?: 'EstimateGroupLineModel', label?: string | null, value?: string | null, class?: string | null }> | null }> | null, responsibility?: { __typename?: 'EstimateGroupLineModel', label?: string | null, value?: string | null, class?: string | null } | null } | null, estimateSession?: { __typename?: 'EstimateSession', externalReferenceId?: string | null, tags?: any | null, status?: string | null, id?: string | null } | null, attachments?: Array<{ __typename?: 'EstimateAttachment', id: string, type?: string | null, content?: { __typename?: 'EmbeddedEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | { __typename?: 'JsonEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | { __typename?: 'PdfEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | null } | null> | null, headerActions?: Array<{ __typename?: 'EstimateHeaderAction', label?: string | null, action?: string | null }> | null } };

export type VerificationFragment = { __typename?: 'Address', verification?: { __typename?: 'AddressVerification', status?: string | null, lastVerifiedOn?: string | null, addressUpdated?: boolean | null, addressStandardized?: boolean | null, validated?: boolean | null, verifiedAddress?: { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null } | null, originalAddress?: { __typename?: 'Address', addressType?: string | null, name?: string | null, city?: string | null, mailingAddress?: string | null, otherDesignation?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, countyOrParish?: string | null, country?: string | null, contactPhone?: string | null } | null, messages?: Array<{ __typename?: 'AddressVerificationMessage', message: string, warning: boolean, error: boolean, footnote?: string | null }> | null } | null };

export type EstimateUpdatedSubscriptionVariables = Exact<{
  externalReferenceId: Scalars['String'];
}>;


export type EstimateUpdatedSubscription = { __typename?: 'Subscription', estimateUpdated?: { __typename?: 'EstimateChanged', estimate?: { __typename?: 'EstimateRenderData', id?: number | null, estimateNumber?: string | null, estimateScore?: string | null, title?: string | null, type?: string | null, patientName?: string | null, pdfData?: string | null, procedures?: Array<string> | null, estimateSessionId?: string | null, createdAt?: any | null, alertMessage?: Array<string> | null, estimateConfig?: any | null, providerNpi?: string | null, estimateStatus?: { __typename?: 'EstimateStatus', result?: string | null, reason?: string | null, reasonFriendly?: string | null } | null, procedureDetails?: Array<{ __typename?: 'EstimateProcedure', code?: string | null, description?: string | null }> | null, primaryServiceLocation?: { __typename?: 'ProviderLocation', name?: string | null, mailingAddress?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, contactPhone?: string | null } | null, summary?: { __typename?: 'EstimateSummary', amount?: number | null, showBenefitDisclaimer?: boolean | null, totals?: Array<{ __typename?: 'EstimateGroupModel', title?: string | null, diagnosisCodes?: Array<string> | null, procedureCode?: string | null, headerVisible?: boolean | null, totalVisible?: boolean | null, totals?: Array<{ __typename?: 'EstimateGroupLineModel', label?: string | null, value?: string | null, class?: string | null }> | null }> | null, responsibility?: { __typename?: 'EstimateGroupLineModel', label?: string | null, value?: string | null, class?: string | null } | null } | null, estimateSession?: { __typename?: 'EstimateSession', externalReferenceId?: string | null, tags?: any | null, status?: string | null, id?: string | null } | null, attachments?: Array<{ __typename?: 'EstimateAttachment', id: string, type?: string | null, content?: { __typename?: 'EmbeddedEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | { __typename?: 'JsonEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | { __typename?: 'PdfEstimateAttachmentContent', password?: string | null, signedUrl?: string | null, type: string } | null } | null> | null, headerActions?: Array<{ __typename?: 'EstimateHeaderAction', label?: string | null, action?: string | null }> | null } | null } | null };

export const ActionFragmentDoc = gql`
    fragment Action on EncounterDetailsGroupModel {
  title
  subTitle
  status
  action
  actionLabel
  payload
  details {
    title
    payload
  }
  fields {
    title
    titleDescription
    status
    value
    action
    actionLabel
    payload
    class
    copyToClipboard
    category {
      categoryTitle
      categoryOrder
    }
  }
}
    `;
export const EstimateRenderFieldsFragmentDoc = gql`
    fragment EstimateRenderFields on EstimateRenderData {
  id
  estimateNumber
  estimateScore
  title
  type
  patientName
  pdfData
  estimateStatus {
    result
    reason
    reasonFriendly
  }
  procedures
  procedureDetails {
    code
    description
  }
  primaryServiceLocation {
    name
    mailingAddress
    city
    stateOrProvince
    zipOrPostalCode
    contactPhone
  }
  summary {
    amount
    totals {
      title
      totals {
        label
        value
        class
      }
      diagnosisCodes
      procedureCode
      headerVisible
      totalVisible
    }
    responsibility {
      label
      value
      class
    }
    showBenefitDisclaimer
  }
  estimateSessionId
  estimateSession {
    externalReferenceId
    tags
    status
    id
  }
  createdAt
  alertMessage
  attachments {
    id
    type
    content {
      password
      signedUrl
      type
    }
  }
  headerActions {
    label
    action
  }
  estimateConfig
  providerNpi
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  addressType
  name
  city
  mailingAddress
  otherDesignation
  stateOrProvince
  zipOrPostalCode
  countyOrParish
  country
  contactPhone
}
    `;
export const VerificationFragmentDoc = gql`
    fragment Verification on Address {
  verification {
    status
    lastVerifiedOn
    addressUpdated
    addressStandardized
    verifiedAddress {
      ...Address
    }
    originalAddress {
      ...Address
    }
    validated
    messages {
      message
      warning
      error
      footnote
    }
  }
}
    ${AddressFragmentDoc}`;
export const DownloadPatientStatementDocument = gql`
    query DownloadPatientStatement($patientArgs: StatementArgs!) {
  statementPdf(patientArgs: $patientArgs)
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class DownloadPatientStatementGQL extends Apollo.Query<DownloadPatientStatementQuery, DownloadPatientStatementQueryVariables> {
    override document = DownloadPatientStatementDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindEncountersAdvancedDocument = gql`
    query FindEncountersAdvanced($organizationExternalId: String!, $index: Int, $limit: Int, $locationIds: [Int], $patientName: String, $mrn: String, $visitId: String, $estimateAvailable: Boolean, $date: String, $endDate: String) {
  findEncountersAdvanced(
    organizationExternalId: $organizationExternalId
    index: $index
    limit: $limit
    locationIds: $locationIds
    patientName: $patientName
    mrn: $mrn
    visitId: $visitId
    estimateAvailable: $estimateAvailable
    date: $date
    endDate: $endDate
  ) {
    total
    data {
      id
      visitNumber
      correlationId
      encounterState
      correlationId
      fullName
      consumerNumber
      admitDateTime
      scheduledOn
      formCompleted
      dateOfBirth
      hasEstimate
      location
      organization {
        id
        timezone
      }
      organizationLocation {
        id
        timezone
      }
      primaryInsuranceBenefitStatus
      procedures {
        procedureCode
      }
      patientBase {
        hasCardOnFile
        addresses {
          verification {
            status
          }
        }
        accountNumber
      }
      insurance {
        planId
        payerId
        payerName
        planNetwork
        status
      }
      orgRsfConfigs {
        id
        label
        encounterCompleteForms {
          formSessionId
        }
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class FindEncountersAdvancedGQL extends Apollo.Query<FindEncountersAdvancedQuery, FindEncountersAdvancedQueryVariables> {
    override document = FindEncountersAdvancedDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindEncounterDocument = gql`
    query FindEncounter($organizationExternalId: String!, $encounterId: Int, $visitNumber: String, $externalId: String, $loadDeletedInsurances: Boolean) {
  encounter(
    organizationExternalId: $organizationExternalId
    id: $encounterId
    visitNumber: $visitNumber
    externalId: $externalId
    loadDeletedInsurances: $loadDeletedInsurances
  ) {
    id
    visitNumber
    correlationId
    diagnoses {
      id
      code
      description
    }
    externalId
    encounterState
    correlationId
    fullName
    group
    dateOfBirth
    consumerNumber
    contactPoints {
      system
      value
      use
      rank
      anyText
      consent
    }
    communications {
      alias
      formSessionId
      type
      createdAt
    }
    scheduledOn
    doNotUseInsurances
    hasEstimate
    syncAddresses
    acknowledgedEstimateDisclaimerAt
    acknowledgedEstimateDisclaimer
    createdAt
    updatedAt
    deletedAt
    isRteEligible
    paymentIsEligible
    header {
      fields {
        title
        value
      }
      actions {
        title
        action
        payload
      }
    }
    patientDocuments {
      fields {
        title
        value
      }
    }
    procedures {
      id
      procedureCode
      procedureDisplayName
    }
    actions {
      ...Action
    }
    insuranceActions {
      ...Action
    }
    estimate {
      id
      estimateStatus {
        result
        reasonFriendly
        reason
      }
    }
    organization {
      id
      timezone
      externalReferenceId
    }
    organizationLocation {
      id
      timezone
    }
    orgRsfConfigs {
      id
      label
      encounterCompleteForms {
        formSessionId
      }
    }
    patientBase {
      nameGiven
      nameMiddle
      nameFamily
      sex
      dateOfBirth
      phoneNumbers {
        useCode
        phoneNumber
      }
      emails {
        emailAddress
      }
      addresses {
        ...Address
        ...Verification
      }
      accountNumber
      emergencyContactBase {
        nameFamily
        nameGiven
        nameMiddle
        namePrefix
        nameSuffix
        sex
        dateOfBirth
        patientRelationship
        addresses {
          mailingAddress
          city
          stateOrProvince
          zipOrPostalCode
          otherDesignation
        }
        phoneNumbers {
          phoneNumber
        }
        emails {
          emailAddress
        }
        contactPoints {
          system
          value
          use
          rank
          anyText
          consent
        }
      }
      mrn
    }
    guarantorBase {
      nameGiven
      nameFamily
      nameMiddle
      namePrefix
      nameSuffix
      sex
      dateOfBirth
      addresses {
        ...Address
        ...Verification
      }
      phoneNumbers {
        phoneNumber
        useCode
      }
      emails {
        emailAddress
      }
      contactPoints {
        system
        value
        use
        rank
        anyText
        consent
      }
      relationship
      ssn
    }
    language
    insurances {
      id
      priority
      planId
      payerId
      planType
      planMasterId
      policyNumber
      payerName
      groupNumber
      groupName
      insuredNameFamily
      insuredNameGiven
      insuredNameMiddle
      insuredNameSuffix
      insuredNamePrefix
      insuredDob
      insuredRelationship
      insuredSex
      insuredSsn
      hicNumber
      medicaidCaseNumber
      studentIndicator
      memberNumber
      isMemberSubscriber
      dateOfServiceBegin
      dateOfServiceEnd
      planExpirationDate
      planEffectiveDate
      status
      planName
      planNetwork
      isRteEligible
      imageFront
      imageBack
      deletedAt
    }
    payments {
      id
      consumerNumber
      accountNumber
      transactionId
      transactionDate
      transactionType
      transactionStatus
      paymentMethod
      paymentSource
      entryMode
      confirmationNumber
      amount
    }
    arrivedNotes {
      noteId
      createdDate
      modifiedDate
      noteType
      emailAddress
      userId
      checkinId
      patientId
      notes
    }
    alerts {
      id
      type
      label
      subLabel
      severity
      createdAt
      updatedAt
    }
    auxiliaryData {
      key
      value
    }
  }
}
    ${ActionFragmentDoc}
${AddressFragmentDoc}
${VerificationFragmentDoc}`;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class FindEncounterGQL extends Apollo.Query<FindEncounterQuery, FindEncounterQueryVariables> {
    override document = FindEncounterDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindEncountersDocument = gql`
    query FindEncounters($organizationExternalId: String!, $index: Int, $limit: Int, $encountersId: Int, $searchText: String, $searchTerms: [String], $organizationLocationId: Int, $externalId: String) {
  encounters(
    organizationExternalId: $organizationExternalId
    index: $index
    limit: $limit
    id: $encountersId
    searchText: $searchText
    searchTerms: $searchTerms
    organizationLocationId: $organizationLocationId
    externalId: $externalId
  ) {
    total
    data {
      id
      visitNumber
      correlationId
      encounterState
      correlationId
      fullName
      consumerNumber
      admitDateTime
      scheduledOn
      formCompleted
      dateOfBirth
      hasEstimate
      location
      organization {
        id
        timezone
      }
      organizationLocation {
        id
        timezone
      }
      primaryInsuranceBenefitStatus
      procedures {
        procedureCode
      }
      patientBase {
        hasCardOnFile
        addresses {
          verification {
            status
          }
        }
        accountNumber
        mrn
      }
      insurance {
        planId
        payerId
        payerName
        planNetwork
        status
      }
      orgRsfConfigs {
        id
        label
        encounterCompleteForms {
          formSessionId
        }
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class FindEncountersGQL extends Apollo.Query<FindEncountersQuery, FindEncountersQueryVariables> {
    override document = FindEncountersDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEncounterEngagementsDocument = gql`
    query GetEncounterEngagements($organizationId: Float!, $startDate: DateTime, $endDate: DateTime, $sort: [EngagementSortArgs!], $filter: JSON, $startRow: Float, $endRow: Float) {
  encounterEngagements(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
    sort: $sort
    filter: $filter
    startRow: $startRow
    endRow: $endRow
  ) {
    lastRow
    rows {
      id
      engagementIdentifier
      createdAt
      updatedAt
      completedAt
      currentStatus
      events {
        id
        eventType
        sourceEvent
        createdAt
        updatedAt
      }
      encounter {
        id
        visitNumber
        encounterBase {
          nameFamily
          nameGiven
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class GetEncounterEngagementsGQL extends Apollo.Query<GetEncounterEngagementsQuery, GetEncounterEngagementsQueryVariables> {
    override document = GetEncounterEngagementsDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEncounterWithEngagementsDocument = gql`
    query GetEncounterWithEngagements($organizationId: Float!, $sort: [EngagementSortArgs!], $filter: JSON, $startRow: Float, $endRow: Float, $withExistingEngagement: Boolean!) {
  encountersWithEngagements(
    organizationId: $organizationId
    sort: $sort
    filter: $filter
    startRow: $startRow
    endRow: $endRow
    withExistingEngagement: $withExistingEngagement
  ) {
    lastRow
    rows {
      id
      visitNumber
      createdAt
      auxiliaryData {
        key
        value
      }
      encounterBase {
        mrn
        nameFamily
        nameGiven
        contactPoints {
          system
          value
        }
      }
      guarantorBase {
        contactPoints {
          system
          value
        }
      }
      engagements {
        id
        engagementIdentifier
        createdAt
        updatedAt
        completedAt
        currentStatus
        events {
          id
          eventType
          sourceEvent
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class GetEncounterWithEngagementsGQL extends Apollo.Query<GetEncounterWithEngagementsQuery, GetEncounterWithEngagementsQueryVariables> {
    override document = GetEncounterWithEngagementsDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEstimateSummaryDocument = gql`
    query GetEstimateSummary($estimateId: Int, $estimateNumber: String, $externalReferenceId: String, $accountId: String, $latest: Boolean, $paths: [String!], $retry: EstimateRetryArgs, $category: String) {
  estimate(
    estimateId: $estimateId
    estimateNumber: $estimateNumber
    externalReferenceId: $externalReferenceId
    accountId: $accountId
    latest: $latest
    paths: $paths
    retry: $retry
    category: $category
  ) {
    createdAt
    updatedAt
    deletedAt
    id
    estimateNumber
    planId
    payerId
    payerName
    planType
    policyNumber
    groupNumber
    groupName
    totalPatientResponsibility
    totalAllowedAmount
    appliedToDeductible
    dedRemainingIndAmount
    dedRemainingFamAmount
    oopIndUsedAmount
    oopIndMaxAmount
    oopFamUsedAmount
    oopFamMaxAmount
    oopIndMaxMet
    oopFamMaxMet
    deductibleMet
    outOfNetwork
    isSelfPay
    hasBenefits
    dedFamRemainingAfterEstimate
    dedIndRemainingAfterEstimate
    dedFamMaxAmount
    dedIndMaxAmount
    estimateStatus {
      createdAt
      updatedAt
      deletedAt
      id
      result
      reason
      reasonFriendly
      hasCdm
      hasContract
      hasRte
      copayOnly
    }
    accountId
    estimateLogId
    estimateStatusId
    estimateSessionId
    estimateStatementId
    payerMasterId
    planMasterId
    source
    type
    patientName
    patientMrn
    patientDob
    primaryService
    primaryServiceScheduled
    diagnoses {
      id
      code
      description
    }
    estimateScore {
      score
      scoringAlgorithmVersion
    }
    estimateSession {
      externalReferenceId
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class GetEstimateSummaryGQL extends Apollo.Query<GetEstimateSummaryQuery, GetEstimateSummaryQueryVariables> {
    override document = GetEstimateSummaryDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEstimatesSummaryDocument = gql`
    query GetEstimatesSummary($index: Int, $limit: Int, $searchText: String, $accountId: String, $sessionType: String) {
  estimates(
    index: $index
    limit: $limit
    searchText: $searchText
    accountId: $accountId
    sessionType: $sessionType
  ) {
    createdAt
    updatedAt
    deletedAt
    id
    estimateNumber
    planId
    payerId
    payerName
    planType
    policyNumber
    groupNumber
    groupName
    totalPatientResponsibility
    totalAllowedAmount
    appliedToDeductible
    dedRemainingIndAmount
    dedRemainingFamAmount
    oopIndUsedAmount
    oopIndMaxAmount
    oopFamUsedAmount
    oopFamMaxAmount
    oopIndMaxMet
    oopFamMaxMet
    deductibleMet
    outOfNetwork
    isSelfPay
    hasBenefits
    dedFamRemainingAfterEstimate
    dedIndRemainingAfterEstimate
    dedFamMaxAmount
    dedIndMaxAmount
    accountId
    estimateLogId
    estimateStatusId
    estimateSessionId
    estimateStatementId
    payerMasterId
    planMasterId
    source
    type
    patientName
    patientMrn
    patientDob
    primaryService
    primaryServiceScheduled
    estimateSession {
      externalReferenceId
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class GetEstimatesSummaryGQL extends Apollo.Query<GetEstimatesSummaryQuery, GetEstimatesSummaryQueryVariables> {
    override document = GetEstimatesSummaryDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientImagesDocument = gql`
    query GetPatientImages($patientArgs: PatientArgs!) {
  images(patientArgs: $patientArgs) {
    documents {
      sessionId
      organizationId
      images {
        formId
        image {
          name
          size
          type
          b64File
          s3url
          s3urlSigned
        }
        createdAt
      }
      files {
        sessionId
        formId
        viewOnlyId
        organizationId
        sessionDisposition
        b64file
        fileUrl
        signedUrl
        fileName
        createdAt
      }
      formSessionId
      encounterId
      patientMrn
      visitNumber
      admitDateTime
      sendDateTime
      alias
    }
    visits {
      visitNumber
      admitDateTime
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class GetPatientImagesGQL extends Apollo.Query<GetPatientImagesQuery, GetPatientImagesQueryVariables> {
    override document = GetPatientImagesDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientStatementsDocument = gql`
    query GetPatientStatements($patientArgs: PatientArgs!) {
  statements(patientArgs: $patientArgs) {
    Id
    ClientId
    ConsumerNumber
    StatementId
    StatementNumber
    FirstName
    MiddleName
    LastName
    FullName
    Address1
    Address2
    Address3
    City
    State
    Zip
    Country
    PdfId
    StatementDate
    RunStampDate
    LastStatementDate
    FirstStatementDate
    DunningType
    DunningLevel
    TotalDebits
    TotalCredits
    AmountDue
    TotalBalance
    PaymentDueDate
    PaymentPlanAmountDue
    DiscountPercent
    PromptPayDiscountFlag
    PromptPayDiscountAmount
    PromptPayFlag
    PromptPayEndDate
    StatementMessage
    FileName
    LetterCode
    Facility
    SuppressionFlag
    SuppressionReason
    Score
    BCL
    FPL
    Charity
    CreateDate
    UpdateDate
    CreatedBy
    UpdatedBy
    StatementAccount {
      Id
      ClientId
      ConsumerNumber
      AccountNumber
      StatementId
      AccountTotalBalance
      AccountTotalCharges
      AccountTotalPayments
      AccountTotalAdjustments
      DunningLevel
      DunningMessage
      PaymentPlanFlag
      SuppressionFlag
      SuppressionReason
      CreateDate
      UpdateDate
      CreatedBy
      UpdatedBy
    }
  }
}
    `;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class GetPatientStatementsGQL extends Apollo.Query<GetPatientStatementsQuery, GetPatientStatementsQueryVariables> {
    override document = GetPatientStatementsDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenderEstimateDocument = gql`
    query RenderEstimate($appName: String, $estimateId: Int, $estimateNumber: String, $externalReferenceId: String, $accountId: String, $paths: [String!], $includePdf: Boolean, $latest: Boolean) {
  renderEstimate(
    appName: $appName
    estimateId: $estimateId
    estimateNumber: $estimateNumber
    externalReferenceId: $externalReferenceId
    accountId: $accountId
    paths: $paths
    includePdf: $includePdf
    latest: $latest
  ) {
    ...EstimateRenderFields
  }
}
    ${EstimateRenderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class RenderEstimateGQL extends Apollo.Query<RenderEstimateQuery, RenderEstimateQueryVariables> {
    override document = RenderEstimateDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimateUpdatedDocument = gql`
    subscription EstimateUpdated($externalReferenceId: String!) {
  estimateUpdated(externalReferenceId: $externalReferenceId) {
    estimate {
      ...EstimateRenderFields
    }
  }
}
    ${EstimateRenderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: EncounterGraphQLModule
  })
  export class EstimateUpdatedGQL extends Apollo.Subscription<EstimateUpdatedSubscription, EstimateUpdatedSubscriptionVariables> {
    override document = EstimateUpdatedDocument;
    override client = 'ees-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

  type Omit<T, K extends PropertyKey> = Pick<T, Exclude<keyof T, K>>;

  type WatchQueryOptionsAlone<V> = Omit<Apollo.Query.WatchOptions<any, V>, 'variables'>;

  type QueryOptionsAlone<V> = Omit<Apollo.Query.FetchOptions<any, V>, 'variables'>;

  type SubscriptionOptionsAlone<V> = Omit<Apollo.Subscription.SubscribeOptions<any, V>, 'variables'>;

  @Injectable({ providedIn: EncounterGraphQLModule })
  export class ApolloAngularSDK {
    constructor(
      private downloadPatientStatementGql: DownloadPatientStatementGQL,
      private findEncountersAdvancedGql: FindEncountersAdvancedGQL,
      private findEncounterGql: FindEncounterGQL,
      private findEncountersGql: FindEncountersGQL,
      private getEncounterEngagementsGql: GetEncounterEngagementsGQL,
      private getEncounterWithEngagementsGql: GetEncounterWithEngagementsGQL,
      private getEstimateSummaryGql: GetEstimateSummaryGQL,
      private getEstimatesSummaryGql: GetEstimatesSummaryGQL,
      private getPatientImagesGql: GetPatientImagesGQL,
      private getPatientStatementsGql: GetPatientStatementsGQL,
      private renderEstimateGql: RenderEstimateGQL,
      private estimateUpdatedGql: EstimateUpdatedGQL
    ) {}
      
    downloadPatientStatement(variables: DownloadPatientStatementQueryVariables, options?: QueryOptionsAlone<DownloadPatientStatementQueryVariables>) {
      return this.downloadPatientStatementGql.fetch({ ...(options ?? {}), variables })
    }
    
    downloadPatientStatementWatch(variables: DownloadPatientStatementQueryVariables, options?: WatchQueryOptionsAlone<DownloadPatientStatementQueryVariables>) {
      return this.downloadPatientStatementGql.watch({ ...(options ?? {}), variables })
    }
    
    findEncountersAdvanced(variables: FindEncountersAdvancedQueryVariables, options?: QueryOptionsAlone<FindEncountersAdvancedQueryVariables>) {
      return this.findEncountersAdvancedGql.fetch({ ...(options ?? {}), variables })
    }
    
    findEncountersAdvancedWatch(variables: FindEncountersAdvancedQueryVariables, options?: WatchQueryOptionsAlone<FindEncountersAdvancedQueryVariables>) {
      return this.findEncountersAdvancedGql.watch({ ...(options ?? {}), variables })
    }
    
    findEncounter(variables: FindEncounterQueryVariables, options?: QueryOptionsAlone<FindEncounterQueryVariables>) {
      return this.findEncounterGql.fetch({ ...(options ?? {}), variables })
    }
    
    findEncounterWatch(variables: FindEncounterQueryVariables, options?: WatchQueryOptionsAlone<FindEncounterQueryVariables>) {
      return this.findEncounterGql.watch({ ...(options ?? {}), variables })
    }
    
    findEncounters(variables: FindEncountersQueryVariables, options?: QueryOptionsAlone<FindEncountersQueryVariables>) {
      return this.findEncountersGql.fetch({ ...(options ?? {}), variables })
    }
    
    findEncountersWatch(variables: FindEncountersQueryVariables, options?: WatchQueryOptionsAlone<FindEncountersQueryVariables>) {
      return this.findEncountersGql.watch({ ...(options ?? {}), variables })
    }
    
    getEncounterEngagements(variables: GetEncounterEngagementsQueryVariables, options?: QueryOptionsAlone<GetEncounterEngagementsQueryVariables>) {
      return this.getEncounterEngagementsGql.fetch({ ...(options ?? {}), variables })
    }
    
    getEncounterEngagementsWatch(variables: GetEncounterEngagementsQueryVariables, options?: WatchQueryOptionsAlone<GetEncounterEngagementsQueryVariables>) {
      return this.getEncounterEngagementsGql.watch({ ...(options ?? {}), variables })
    }
    
    getEncounterWithEngagements(variables: GetEncounterWithEngagementsQueryVariables, options?: QueryOptionsAlone<GetEncounterWithEngagementsQueryVariables>) {
      return this.getEncounterWithEngagementsGql.fetch({ ...(options ?? {}), variables })
    }
    
    getEncounterWithEngagementsWatch(variables: GetEncounterWithEngagementsQueryVariables, options?: WatchQueryOptionsAlone<GetEncounterWithEngagementsQueryVariables>) {
      return this.getEncounterWithEngagementsGql.watch({ ...(options ?? {}), variables })
    }
    
    getEstimateSummary(variables?: GetEstimateSummaryQueryVariables, options?: QueryOptionsAlone<GetEstimateSummaryQueryVariables>) {
      return this.getEstimateSummaryGql.fetch({ ...(options ?? {}), variables })
    }
    
    getEstimateSummaryWatch(variables?: GetEstimateSummaryQueryVariables, options?: WatchQueryOptionsAlone<GetEstimateSummaryQueryVariables>) {
      return this.getEstimateSummaryGql.watch({ ...(options ?? {}), variables })
    }
    
    getEstimatesSummary(variables?: GetEstimatesSummaryQueryVariables, options?: QueryOptionsAlone<GetEstimatesSummaryQueryVariables>) {
      return this.getEstimatesSummaryGql.fetch({ ...(options ?? {}), variables })
    }
    
    getEstimatesSummaryWatch(variables?: GetEstimatesSummaryQueryVariables, options?: WatchQueryOptionsAlone<GetEstimatesSummaryQueryVariables>) {
      return this.getEstimatesSummaryGql.watch({ ...(options ?? {}), variables })
    }
    
    getPatientImages(variables: GetPatientImagesQueryVariables, options?: QueryOptionsAlone<GetPatientImagesQueryVariables>) {
      return this.getPatientImagesGql.fetch({ ...(options ?? {}), variables })
    }
    
    getPatientImagesWatch(variables: GetPatientImagesQueryVariables, options?: WatchQueryOptionsAlone<GetPatientImagesQueryVariables>) {
      return this.getPatientImagesGql.watch({ ...(options ?? {}), variables })
    }
    
    getPatientStatements(variables: GetPatientStatementsQueryVariables, options?: QueryOptionsAlone<GetPatientStatementsQueryVariables>) {
      return this.getPatientStatementsGql.fetch({ ...(options ?? {}), variables })
    }
    
    getPatientStatementsWatch(variables: GetPatientStatementsQueryVariables, options?: WatchQueryOptionsAlone<GetPatientStatementsQueryVariables>) {
      return this.getPatientStatementsGql.watch({ ...(options ?? {}), variables })
    }
    
    renderEstimate(variables?: RenderEstimateQueryVariables, options?: QueryOptionsAlone<RenderEstimateQueryVariables>) {
      return this.renderEstimateGql.fetch({ ...(options ?? {}), variables })
    }
    
    renderEstimateWatch(variables?: RenderEstimateQueryVariables, options?: WatchQueryOptionsAlone<RenderEstimateQueryVariables>) {
      return this.renderEstimateGql.watch({ ...(options ?? {}), variables })
    }
    
    estimateUpdated(variables: EstimateUpdatedSubscriptionVariables, options?: SubscriptionOptionsAlone<EstimateUpdatedSubscriptionVariables>) {
      return this.estimateUpdatedGql.subscribe({ ...(options ?? {}), variables })
    }
  }